<template>
    <div class="container-fluid">
        <Loading :active="loading" :is-full-page="true" />
        <div class="pa-3">
            <v-card class="mb-3">
                <v-card-text class="pa-3 font-weight-light white black--text">
                    <v-icon class="primary--text lighten-2 pa-2">
                        mdi-bullhorn
                    </v-icon>
                    Administração > Gerenciamento de Divulgações de Novidades
                </v-card-text>
            </v-card>
            <v-card class="pa-6">
                <v-row class="mb-4" align="center">
                    <v-col cols="12" class="text-center">
                        <h2 class="text-h4 primary--text font-weight-regular">
                            Gerenciamento de Divulgações de Novidades
                        </h2>
                    </v-col>
                </v-row>
                <v-row class="mb-4" align="center">
                    <v-col cols="8" md="6" class="text-left">
                        <v-btn
                            color="success"
                            :large="!$vuetify.breakpoint.xs"
                            :small="$vuetify.breakpoint.xs"
                            @click="novaDivulgacao"
                            class="font-weight-medium"
                            elevation="2"
                        >
                            <v-icon
                                left
                                :size="$vuetify.breakpoint.xs ? 18 : 24"
                                >mdi-plus</v-icon
                            >
                            Nova Divulgação
                        </v-btn>
                    </v-col>
                    <v-col
                        cols="4"
                        md="6"
                        :class="
                            $vuetify.breakpoint.xs
                                ? 'text-left pl-0'
                                : 'text-right'
                        "
                    >
                        <v-select
                            v-model="filtroStatus"
                            :items="opcoesStatus"
                            label="Status"
                            outlined
                            dense
                            hide-details
                            :style="
                                $vuetify.breakpoint.xs
                                    ? 'max-width: 120px;'
                                    : 'max-width: 200px; margin-left: auto;'
                            "
                            @change="aplicarFiltros"
                        ></v-select>
                    </v-col>
                </v-row>
                <div class="table-container">
                    <v-data-table
                        :headers="headers"
                        :items="divulgacoesFiltradas"
                        :loading="loading"
                        :options.sync="options"
                        :server-items-length="totalItems"
                        :footer-props="{
                            itemsPerPageOptions: [5, 10, 20, 50],
                            itemsPerPageText: 'Itens por página:',
                            showFirstLastPage: true,
                            showCurrentPage: true
                        }"
                        class="elevation-1 responsive-table"
                        loading-text="Carregando divulgações..."
                        no-data-text="Nenhuma divulgação encontrada. Crie uma nova!"
                        sort-by="data_envio"
                        sort-desc
                        mobile-breakpoint="960"
                        :hide-default-footer="$vuetify.breakpoint.xs"
                    >
                        <template v-slot:[`item.assunto`]="{ item }">
                            <div class="d-flex align-center subject-cell">
                                <div
                                    v-if="item.imagem"
                                    class="mr-3 image-container"
                                >
                                    <v-avatar
                                        :size="$vuetify.breakpoint.xs ? 32 : 40"
                                        tile
                                        rounded="4"
                                        class="subject-avatar"
                                    >
                                        <v-img
                                            :src="item.imagem"
                                            aspect-ratio="1"
                                        ></v-img>
                                    </v-avatar>
                                </div>
                                <div v-else class="mr-3 image-container">
                                    <v-avatar
                                        :size="$vuetify.breakpoint.xs ? 32 : 40"
                                        tile
                                        rounded="4"
                                        color="grey lighten-3"
                                        class="subject-avatar"
                                    >
                                        <v-icon
                                            color="grey"
                                            :size="
                                                $vuetify.breakpoint.xs ? 16 : 20
                                            "
                                        >
                                            mdi-image-off
                                        </v-icon>
                                    </v-avatar>
                                </div>
                                <div class="subject-content">
                                    <a
                                        @click="visualizarDivulgacao(item)"
                                        class="text-decoration-none primary--text font-weight-medium cursor-pointer subject-link"
                                        style="cursor: pointer;"
                                    >
                                        {{ item.assunto }}
                                    </a>
                                    <div
                                        v-if="
                                            item.nomeImagem &&
                                                !$vuetify.breakpoint.xs
                                        "
                                        class="text-caption grey--text image-name"
                                    >
                                        <v-icon x-small class="mr-1"
                                            >mdi-image</v-icon
                                        >
                                        {{ item.nomeImagem }}
                                    </div>
                                    <div
                                        v-if="$vuetify.breakpoint.xs"
                                        class="mobile-status mt-1"
                                    >
                                        <v-chip
                                            x-small
                                            :color="
                                                item.status === 'rascunho'
                                                    ? 'orange'
                                                    : 'green'
                                            "
                                            text-color="white"
                                            class="mr-1"
                                        >
                                            {{
                                                item.status === 'rascunho'
                                                    ? 'Rascunho'
                                                    : 'Enviado'
                                            }}
                                        </v-chip>
                                        <v-chip
                                            v-if="item.enviadoVia?.email"
                                            x-small
                                            color="#1976d2"
                                            text-color="white"
                                            class="mr-1"
                                            outlined
                                        >
                                            <v-icon x-small left
                                                >mdi-email-outline</v-icon
                                            >
                                            Email
                                        </v-chip>
                                        <v-chip
                                            v-if="item.enviadoVia?.popup"
                                            x-small
                                            color="#7c4dff"
                                            text-color="white"
                                            class="mr-1"
                                            outlined
                                        >
                                            <v-icon x-small left
                                                >mdi-message-alert-outline</v-icon
                                            >
                                            Pop
                                        </v-chip>
                                        <v-chip
                                            v-if="
                                                !item.enviadoVia?.email &&
                                                    !item.enviadoVia?.popup
                                            "
                                            x-small
                                            color="grey lighten-2"
                                            text-color="grey darken-1"
                                        >
                                            <v-icon x-small left
                                                >mdi-help-circle-outline</v-icon
                                            >
                                            N/D
                                        </v-chip>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-slot:[`item.enviadoVia`]="{ item }">
                            <div
                                class="methods-container"
                                :class="
                                    $vuetify.breakpoint.xs
                                        ? 'd-flex flex-row'
                                        : 'd-flex flex-column'
                                "
                            >
                                <v-tooltip bottom v-if="item.enviadoVia?.email">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-chip
                                            :small="!$vuetify.breakpoint.xs"
                                            :x-small="$vuetify.breakpoint.xs"
                                            color="#1976d2"
                                            text-color="white"
                                            class="method-chip email-chip"
                                            :class="
                                                $vuetify.breakpoint.xs
                                                    ? 'mr-1'
                                                    : 'mb-1'
                                            "
                                            outlined
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon
                                                left
                                                class="chip-icon"
                                                :size="16"
                                            >
                                                mdi-email-outline
                                            </v-icon>
                                            <span v-if="!$vuetify.breakpoint.xs"
                                                >E-mail</span
                                            >
                                            <span v-else>Email</span>
                                        </v-chip>
                                    </template>
                                    <span
                                        >Enviado por e-mail para os
                                        usuários</span
                                    >
                                </v-tooltip>
                                <v-tooltip bottom v-if="item.enviadoVia?.popup">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-chip
                                            :small="!$vuetify.breakpoint.xs"
                                            :x-small="$vuetify.breakpoint.xs"
                                            color="#7c4dff"
                                            text-color="white"
                                            class="method-chip popup-chip"
                                            outlined
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon
                                                left
                                                class="chip-icon"
                                                :size="16"
                                            >
                                                mdi-message-alert-outline
                                            </v-icon>
                                            <span v-if="!$vuetify.breakpoint.xs"
                                                >Pop-up</span
                                            >
                                            <span v-else>Pop</span>
                                        </v-chip>
                                    </template>
                                    <span
                                        >Exibido como pop-up na plataforma</span
                                    >
                                </v-tooltip>
                                <v-tooltip
                                    bottom
                                    v-if="
                                        !item.enviadoVia?.email &&
                                            !item.enviadoVia?.popup
                                    "
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <div class="method-undefined">
                                            <v-chip
                                                :small="!$vuetify.breakpoint.xs"
                                                :x-small="
                                                    $vuetify.breakpoint.xs
                                                "
                                                color="grey lighten-2"
                                                text-color="grey darken-1"
                                                class="method-chip undefined-chip"
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon
                                                    left
                                                    class="chip-icon"
                                                    :size="16"
                                                >
                                                    mdi-help-circle-outline
                                                </v-icon>
                                                <span
                                                    v-if="
                                                        !$vuetify.breakpoint.xs
                                                    "
                                                    >Não definido</span
                                                >
                                                <span v-else>N/D</span>
                                            </v-chip>
                                        </div>
                                    </template>
                                    <span
                                        >Métodos de envio não foram
                                        definidos</span
                                    >
                                </v-tooltip>
                            </div>
                        </template>
                        <template v-slot:[`item.data_envio`]="{ item }">
                            <span
                                v-if="item.status === 'rascunho'"
                                class="grey--text"
                            >
                                Rascunho
                            </span>
                            <span v-else>
                                {{ formatarData(item.dataEnvio) }}
                            </span>
                        </template>
                        <template v-slot:[`item.expira_em`]="{ item }">
                            <div
                                v-if="item.expira_em"
                                class="d-flex align-center"
                            >
                                <v-icon
                                    :color="
                                        getStatusExpiracaoColor(item.expira_em)
                                    "
                                    small
                                    class="mr-2"
                                >
                                    {{ getStatusExpiracaoIcon(item.expira_em) }}
                                </v-icon>
                                <div>
                                    <div
                                        :class="
                                            getStatusExpiracaoColor(
                                                item.expira_em
                                            ) + '--text'
                                        "
                                        class="font-weight-medium"
                                    >
                                        {{
                                            formatarDataExpiracao(
                                                item.expira_em
                                            )
                                        }}
                                    </div>
                                    <div
                                        class="caption grey--text"
                                        v-if="
                                            getTempoParaExpiracao(
                                                item.expira_em
                                            )
                                        "
                                    >
                                        {{
                                            getTempoParaExpiracao(
                                                item.expira_em
                                            )
                                        }}
                                    </div>
                                </div>
                            </div>
                            <span v-else class="grey--text">
                                <v-icon small class="mr-1 grey--text"
                                    >mdi-infinity</v-icon
                                >
                                Sem expiração
                            </span>
                        </template>
                        <template v-slot:[`item.acoes`]="{ item }">
                            <v-btn
                                color="primary"
                                :small="!$vuetify.breakpoint.xs"
                                :x-small="$vuetify.breakpoint.xs"
                                outlined
                                @click="visualizarDivulgacao(item)"
                                class="font-weight-medium action-btn"
                            >
                                <v-icon
                                    left
                                    :small="!$vuetify.breakpoint.xs"
                                    :x-small="$vuetify.breakpoint.xs"
                                >
                                    mdi-eye
                                </v-icon>
                                <span v-if="!$vuetify.breakpoint.xs"
                                    >Visualizar</span
                                >
                                <span v-else>Ver</span>
                            </v-btn>
                        </template>
                        <template v-slot:[`header.assunto`]="{ header }">
                            <span class="font-weight-bold">
                                {{ header.text }}
                                <v-icon small>mdi-arrow-up-down</v-icon>
                            </span>
                        </template>
                        <template v-slot:[`header.data_envio`]="{ header }">
                            <span class="font-weight-bold">
                                {{ header.text }}
                                <v-icon small>mdi-arrow-up-down</v-icon>
                            </span>
                        </template>
                    </v-data-table>
                    <div
                        v-if="$vuetify.breakpoint.xs"
                        class="mobile-pagination"
                    >
                        <v-pagination
                            v-model="options.page"
                            :length="
                                Math.ceil(totalItems / options.itemsPerPage)
                            "
                            :total-visible="5"
                            circle
                        ></v-pagination>
                    </div>
                </div>
            </v-card>
        </div>
        <v-dialog
            v-model="dialogVisualizacaoImagem"
            max-width="50vw"
            overlay-color="rgba(0,0,0,0.8)"
        >
            <v-card class="modal-visualizacao-imagem">
                <v-card-title
                    class="pa-2 d-flex justify-space-between align-center"
                >
                    <span class="text-h6">Visualizar Imagem</span>
                    <v-btn
                        icon
                        @click="dialogVisualizacaoImagem = false"
                        class="close-btn"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text
                    class="pa-0 d-flex justify-center align-center"
                    style="min-height: 50vh;"
                >
                    <v-img
                        v-if="imagemVisualizacao"
                        :src="imagemVisualizacao"
                        contain
                        max-height="80vh"
                        max-width="100%"
                        class="imagem-fullscreen"
                    ></v-img>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogVisualizacao" max-width="800px" persistent>
            <v-card v-if="divulgacaoSelecionada">
                <v-card-title class="primary white--text">
                    <v-icon left class="white--text">mdi-eye</v-icon>
                    Visualizar Divulgação
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="dialogVisualizacao = false"
                        class="close-btn"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pa-6">
                    <v-row>
                        <v-col cols="12">
                            <h3 class="text-h5 mb-3">
                                {{ divulgacaoSelecionada.assunto }}
                            </h3>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6">
                            <v-chip
                                :color="
                                    divulgacaoSelecionada.status === 'enviado'
                                        ? 'success'
                                        : 'grey'
                                "
                                text-color="white"
                                small
                            >
                                {{
                                    divulgacaoSelecionada.status === 'enviado'
                                        ? 'Enviado'
                                        : 'Rascunho'
                                }}
                            </v-chip>
                        </v-col>
                        <v-col cols="6" class="text-right">
                            <span class="grey--text">
                                {{
                                    divulgacaoSelecionada.status === 'enviado'
                                        ? formatarData(
                                              divulgacaoSelecionada.dataEnvio
                                          )
                                        : 'Ainda não enviado'
                                }}
                            </span>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="12">
                            <div class="d-flex align-center">
                                <v-icon
                                    small
                                    class="mr-2"
                                    :color="
                                        divulgacaoSelecionada.expira_em
                                            ? getStatusExpiracaoColor(
                                                  divulgacaoSelecionada.expira_em
                                              )
                                            : 'grey'
                                    "
                                >
                                    {{
                                        divulgacaoSelecionada.expira_em
                                            ? getStatusExpiracaoIcon(
                                                  divulgacaoSelecionada.expira_em
                                              )
                                            : 'mdi-infinity'
                                    }}
                                </v-icon>
                                <div v-if="divulgacaoSelecionada.expira_em">
                                    <span
                                        class="text-body-2 font-weight-medium"
                                        :class="
                                            getStatusExpiracaoColor(
                                                divulgacaoSelecionada.expira_em
                                            ) + '--text'
                                        "
                                    >
                                        Expira em:
                                        {{
                                            formatarDataExpiracao(
                                                divulgacaoSelecionada.expira_em
                                            )
                                        }}
                                    </span>
                                    <span
                                        v-if="
                                            getTempoParaExpiracao(
                                                divulgacaoSelecionada.expira_em
                                            )
                                        "
                                        class="text-caption grey--text ml-2"
                                    >
                                        ({{
                                            getTempoParaExpiracao(
                                                divulgacaoSelecionada.expira_em
                                            )
                                        }})
                                    </span>
                                </div>
                                <div v-else>
                                    <span class="text-body-2 grey--text">
                                        Sem data de expiração
                                    </span>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row
                        v-if="
                            divulgacaoSelecionada.imagem ||
                                divulgacaoSelecionada.enviadoVia
                        "
                        class="mt-2"
                    >
                        <v-col
                            cols="12"
                            md="6"
                            v-if="divulgacaoSelecionada.imagem"
                        >
                            <v-card
                                outlined
                                class="pa-3"
                                style="min-height: 120px;"
                            >
                                <div class="text-subtitle2 mb-2">
                                    <v-icon small class="mr-1"
                                        >mdi-image</v-icon
                                    >
                                    Imagem da Divulgação
                                </div>
                                <div
                                    class="d-flex align-center justify-space-between"
                                >
                                    <div class="d-flex align-center">
                                        <v-avatar
                                            size="60"
                                            tile
                                            rounded="4"
                                            class="mr-3"
                                        >
                                            <v-img
                                                :src="
                                                    divulgacaoSelecionada.imagem
                                                "
                                                aspect-ratio="1"
                                            ></v-img>
                                        </v-avatar>
                                        <div>
                                            <div
                                                class="text-body-2 font-weight-medium"
                                            >
                                                {{
                                                    divulgacaoSelecionada.nomeImagem ||
                                                        'Imagem anexada'
                                                }}
                                            </div>
                                            <div
                                                class="text-caption grey--text"
                                            >
                                                Anexo da divulgação
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col
                            cols="12"
                            md="6"
                            v-if="divulgacaoSelecionada.enviadoVia"
                        >
                            <v-card
                                outlined
                                class="pa-3"
                                style="min-height: 120px;"
                            >
                                <div class="text-subtitle2 mb-2">
                                    <v-icon small class="mr-1">mdi-send</v-icon>
                                    Métodos de Envio
                                </div>
                                <div class="d-flex flex-wrap gap-2">
                                    <v-chip
                                        v-if="
                                            divulgacaoSelecionada.enviadoVia
                                                ?.email
                                        "
                                        small
                                        color="primary"
                                        text-color="white"
                                        class="mr-2 mb-1"
                                    >
                                        <v-icon small left>mdi-email</v-icon>
                                        E-mail
                                    </v-chip>
                                    <v-chip
                                        v-if="
                                            divulgacaoSelecionada.enviadoVia
                                                ?.popup
                                        "
                                        small
                                        color="secondary"
                                        text-color="white"
                                        class="mb-1"
                                    >
                                        <v-icon small left
                                            >mdi-message-alert</v-icon
                                        >
                                        Pop-up no Sistema
                                    </v-chip>
                                </div>
                                <div
                                    v-if="
                                        !divulgacaoSelecionada.enviadoVia
                                            ?.email &&
                                            !divulgacaoSelecionada.enviadoVia
                                                ?.popup
                                    "
                                    class="grey--text text-body-2"
                                >
                                    Nenhum método de envio definido
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-divider class="my-4"></v-divider>
                    <div class="divulgacao-info">
                        <div class="text-subtitle2 mb-3">
                            <v-icon small class="mr-1">mdi-information</v-icon>
                            Detalhes da Divulgação
                        </div>
                        <v-card outlined class="pa-4">
                            <div
                                class="d-flex align-center justify-space-between"
                            >
                                <div class="d-flex align-center">
                                    <div
                                        v-if="divulgacaoSelecionada.imagem"
                                        class="mr-4"
                                    >
                                        <v-avatar size="80" tile rounded="8">
                                            <v-img
                                                :src="
                                                    divulgacaoSelecionada.imagem
                                                "
                                                aspect-ratio="1"
                                            ></v-img>
                                        </v-avatar>
                                    </div>
                                    <div v-else class="mr-4">
                                        <v-avatar
                                            size="80"
                                            tile
                                            rounded="8"
                                            color="grey lighten-3"
                                        >
                                            <v-icon color="grey" size="40"
                                                >mdi-image-off</v-icon
                                            >
                                        </v-avatar>
                                    </div>
                                    <div class="flex-grow-1">
                                        <div
                                            class="text-h6 font-weight-medium mb-2"
                                        >
                                            {{ divulgacaoSelecionada.assunto }}
                                        </div>
                                        <div
                                            v-if="
                                                divulgacaoSelecionada.nomeImagem
                                            "
                                            class="text-caption grey--text"
                                        >
                                            <v-icon x-small class="mr-1"
                                                >mdi-attachment</v-icon
                                            >
                                            {{
                                                divulgacaoSelecionada.nomeImagem
                                            }}
                                        </div>
                                        <div
                                            v-else-if="
                                                !divulgacaoSelecionada.imagem
                                            "
                                            class="text-caption grey--text"
                                        >
                                            Nenhuma imagem anexada
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                v-if="divulgacaoSelecionada.imagem"
                                class="mt-3 text-center"
                            >
                                <v-btn
                                    color="primary"
                                    :small="!$vuetify.breakpoint.xs"
                                    :x-small="$vuetify.breakpoint.xs"
                                    @click="
                                        visualizarImagemCompleta(
                                            divulgacaoSelecionada.imagem
                                        )
                                    "
                                    class="btn-visualizar-imagem"
                                >
                                    <v-icon
                                        left
                                        :small="!$vuetify.breakpoint.xs"
                                        :x-small="$vuetify.breakpoint.xs"
                                    >
                                        mdi-magnify-plus
                                    </v-icon>
                                    <span v-if="!$vuetify.breakpoint.xs"
                                        >Visualizar Imagem</span
                                    >
                                    <span v-else>Ver</span>
                                </v-btn>
                            </div>
                        </v-card>
                    </div>

                    <div
                        v-if="
                            divulgacaoSelecionada.destinatariosAdicionais &&
                                divulgacaoSelecionada.destinatariosAdicionais
                                    .length > 0
                        "
                        class="destinatarios-adicionais mt-4"
                    >
                        <v-divider class="mb-4"></v-divider>
                        <div class="text-subtitle2 mb-3">
                            <v-icon small class="mr-1"
                                >mdi-account-multiple-plus</v-icon
                            >
                            Destinatários Adicionais ({{
                                divulgacaoSelecionada.destinatariosAdicionais
                                    .length
                            }})
                        </div>
                        <v-card outlined class="pa-0">
                            <div class="destinatarios-table-container">
                                <v-simple-table dense>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th
                                                    class="text-left font-weight-bold"
                                                >
                                                    #
                                                </th>
                                                <th
                                                    class="text-left font-weight-bold"
                                                >
                                                    E-mail
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(email,
                                                index) in divulgacaoSelecionada.destinatariosAdicionais"
                                                :key="index"
                                                class="destinatario-row"
                                            >
                                                <td
                                                    class="text-caption grey--text"
                                                >
                                                    {{ index + 1 }}
                                                </td>
                                                <td class="text-body-2">
                                                    <v-icon
                                                        x-small
                                                        class="mr-1 grey--text"
                                                        >mdi-email-outline</v-icon
                                                    >
                                                    {{ email }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </div>
                        </v-card>
                    </div>
                </v-card-text>
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey"
                        text
                        @click="dialogVisualizacao = false"
                        class="mr-3"
                        :block="$vuetify.breakpoint.xs"
                        small
                    >
                        <v-icon left small>mdi-close</v-icon>
                        Fechar
                    </v-btn>
                    <v-btn
                        v-if="divulgacaoSelecionada.status === 'rascunho'"
                        color="primary"
                        elevation="2"
                        @click="editarDivulgacao(divulgacaoSelecionada)"
                        class="btn-editar font-weight-medium"
                        :block="$vuetify.breakpoint.xs"
                        small
                    >
                        <v-icon left small>mdi-pencil</v-icon>
                        Editar Rascunho
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogNovaDivulgacao"
            max-width="1200px"
            persistent
            overlay-color="rgba(0,0,0,0.75)"
            transition="dialog-bottom-transition"
            :fullscreen="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
            scrollable
        >
            <v-card class="modal-nova-divulgacao">
                <v-card-title
                    class="modal-header d-flex align-center justify-space-between pa-6"
                >
                    <div class="header-content d-flex align-center">
                        <div class="header-icon">
                            <v-icon size="32" color="primary"
                                >mdi-bullhorn</v-icon
                            >
                        </div>
                        <div class="header-text ml-3">
                            <h2
                                class="text-h5 font-weight-bold primary--text mb-1"
                            >
                                {{
                                    modoEdicao
                                        ? 'Editar Divulgação'
                                        : 'Nova Divulgação'
                                }}
                            </h2>
                            <p class="text-body-2 grey--text ma-0">
                                {{
                                    modoEdicao
                                        ? 'Edite os dados da sua divulgação'
                                        : 'Crie e envie uma nova divulgação para os usuários'
                                }}
                            </p>
                        </div>
                    </div>
                    <v-btn icon large @click="cancelarModal" class="close-btn">
                        <v-icon size="24">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <div class="progress-indicator pa-4 pb-0">
                    <v-stepper
                        v-model="stepAtual"
                        alt-labels
                        flat
                        class="elevation-0"
                        style="box-shadow: none;"
                    >
                        <v-stepper-header
                            class="elevation-0"
                            style="box-shadow: none;"
                        >
                            <v-stepper-step
                                :complete="stepAtual > 1"
                                step="1"
                                color="primary"
                                complete-icon="mdi-check"
                            >
                                Conteúdo
                            </v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step
                                :complete="stepAtual > 2"
                                step="2"
                                color="primary"
                                complete-icon="mdi-check"
                            >
                                Destinatários
                            </v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step
                                step="3"
                                color="primary"
                                complete-icon="mdi-check"
                            >
                                Revisão
                            </v-stepper-step>
                        </v-stepper-header>
                    </v-stepper>
                </div>
                <v-card-text class="pa-0">
                    <div v-show="stepAtual === 1" class="step-content pa-6">
                        <div class="step-title mb-4">
                            <h3 class="text-h6 font-weight-medium">
                                Defina o conteúdo da divulgação
                            </h3>
                            <p class="text-body-2 grey--text mt-1">
                                Adicione o assunto e a imagem que será enviada
                            </p>
                        </div>
                        <v-row>
                            <v-col cols="12">
                                <div class="input-group">
                                    <label class="field-label">
                                        <v-icon
                                            small
                                            class="mr-2"
                                            color="primary"
                                            >mdi-format-title</v-icon
                                        >
                                        Assunto *
                                    </label>
                                    <v-text-field
                                        v-model="novaDivulgacaoForm.assunto"
                                        placeholder="Ex: Novidades da Plataforma — Atualização v2.0"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        counter="100"
                                        maxlength="100"
                                        class="mt-2"
                                        :rules="[
                                            v => !!v || 'Assunto é obrigatório'
                                        ]"
                                    >
                                        <template v-slot:append>
                                            <v-tooltip bottom>
                                                <template
                                                    v-slot:activator="{ on }"
                                                >
                                                    <v-icon
                                                        v-on="on"
                                                        small
                                                        color="grey"
                                                        >mdi-help-circle</v-icon
                                                    >
                                                </template>
                                                <span
                                                    >Título que aparecerá no
                                                    email e popup</span
                                                >
                                            </v-tooltip>
                                        </template>
                                    </v-text-field>
                                </div>
                            </v-col>

                            <v-col cols="12">
                                <div class="input-group">
                                    <label class="field-label">
                                        <v-icon
                                            small
                                            class="mr-2"
                                            color="primary"
                                            >mdi-calendar-clock</v-icon
                                        >
                                        Duração da Divulgação *
                                    </label>
                                    <v-text-field
                                        v-model="novaDivulgacaoForm.expiraEm"
                                        type="datetime-local"
                                        label="Data e hora de expiração"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        class="mt-2"
                                        :rules="[
                                            v =>
                                                !!v ||
                                                'Data de expiração é obrigatória',
                                            v =>
                                                new Date(v) > new Date() ||
                                                'Data deve ser no futuro'
                                        ]"
                                        :min="
                                            new Date()
                                                .toISOString()
                                                .substr(0, 16)
                                        "
                                    >
                                        <template v-slot:append>
                                            <v-tooltip bottom>
                                                <template
                                                    v-slot:activator="{ on }"
                                                >
                                                    <v-icon
                                                        v-on="on"
                                                        small
                                                        color="grey"
                                                        >mdi-help-circle</v-icon
                                                    >
                                                </template>
                                                <span
                                                    >Data e hora em que a
                                                    divulgação expirará e não
                                                    será mais exibida</span
                                                >
                                            </v-tooltip>
                                        </template>
                                    </v-text-field>
                                </div>
                            </v-col>

                            <v-col cols="12">
                                <div class="input-group">
                                    <label class="field-label">
                                        <v-icon
                                            small
                                            class="mr-2"
                                            color="primary"
                                            >mdi-image</v-icon
                                        >
                                        Imagem
                                        <span
                                            v-if="!modoEdicao"
                                            class="red--text"
                                            >*</span
                                        >
                                    </label>
                                    <div
                                        v-if="!modoEdicao"
                                        class="text-caption grey--text mb-2"
                                    >
                                        <v-icon small color="info" class="mr-1"
                                            >mdi-information</v-icon
                                        >
                                        Imagem obrigatória para envio. Sem
                                        imagem, só é possível salvar como
                                        rascunho.
                                    </div>
                                    <div
                                        class="upload-zone mt-2"
                                        :class="{ dragover: isDragOver }"
                                        @drop="onDrop"
                                        @dragover.prevent="isDragOver = true"
                                        @dragleave="isDragOver = false"
                                        @click="triggerFileSelect"
                                    >
                                        <div
                                            v-if="!imagemPreview"
                                            class="upload-empty"
                                        >
                                            <v-icon
                                                size="48"
                                                color="grey lighten-1"
                                                >mdi-cloud-upload</v-icon
                                            >
                                            <p
                                                class="text-body-2 grey--text mt-2 mb-1"
                                            >
                                                Arraste uma imagem aqui ou
                                                clique para selecionar
                                            </p>
                                            <p class="text-caption grey--text">
                                                JPG, PNG, GIF — até 5 MB
                                            </p>
                                        </div>
                                        <div v-else class="upload-preview">
                                            <img
                                                :src="imagemPreview"
                                                alt="Preview"
                                                class="preview-img"
                                            />
                                            <div class="upload-overlay">
                                                <v-btn
                                                    small
                                                    color="primary"
                                                    fab
                                                    @click.stop="
                                                        visualizarImagemCompleta(
                                                            imagemPreview
                                                        )
                                                    "
                                                    class="mr-2 btn-visualizar-imagem"
                                                >
                                                    <v-icon small
                                                        >mdi-magnify-plus</v-icon
                                                    >
                                                </v-btn>
                                                <v-btn
                                                    small
                                                    color="error"
                                                    fab
                                                    @click.stop="removerArquivo"
                                                >
                                                    <v-icon small
                                                        >mdi-delete</v-icon
                                                    >
                                                </v-btn>
                                            </div>
                                        </div>
                                    </div>

                                    <v-file-input
                                        ref="fileInput"
                                        v-model="arquivoSelecionado"
                                        accept="image/jpeg,image/png,image/gif"
                                        @change="onFileSelect"
                                        style="display: none;"
                                    ></v-file-input>
                                    <div
                                        v-if="nomeArquivo"
                                        class="mt-2 d-flex align-center"
                                    >
                                        <v-icon
                                            small
                                            color="success"
                                            class="mr-2"
                                            >mdi-check-circle</v-icon
                                        >
                                        <span class="text-body-2">{{
                                            nomeArquivo
                                        }}</span>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>

                    <div v-show="stepAtual === 2" class="step-content pa-6">
                        <div class="step-title mb-4">
                            <h3 class="text-h6 font-weight-medium">
                                Configure os destinatários
                            </h3>
                            <p class="text-body-2 grey--text mt-1">
                                Escolha como enviar e adicione destinatários
                                extras
                            </p>
                        </div>
                        <v-row>
                            <v-col cols="12" lg="6">
                                <v-alert
                                    type="info"
                                    outlined
                                    dense
                                    class="mb-4"
                                    icon="mdi-information"
                                >
                                    <strong>Todos os usuários ativos</strong>
                                    receberão esta divulgação
                                </v-alert>
                                <div class="input-group">
                                    <label class="field-label">
                                        <v-icon
                                            small
                                            class="mr-2"
                                            color="primary"
                                            >mdi-send</v-icon
                                        >
                                        Métodos de envio *
                                    </label>
                                    <div class="method-cards mt-2">
                                        <v-card
                                            class="method-card"
                                            :class="{
                                                selected:
                                                    novaDivulgacaoForm.enviarVia
                                                        .email
                                            }"
                                            @click="toggleEmail"
                                            outlined
                                        >
                                            <v-card-text class="pa-3">
                                                <div
                                                    class="d-flex align-center"
                                                >
                                                    <v-checkbox
                                                        v-model="
                                                            novaDivulgacaoForm
                                                                .enviarVia.email
                                                        "
                                                        hide-details
                                                        class="ma-0 pa-0 mr-3"
                                                        color="primary"
                                                        @change="
                                                            validarMetodoEnvio
                                                        "
                                                    ></v-checkbox>
                                                    <div>
                                                        <div
                                                            class="d-flex align-center"
                                                        >
                                                            <v-icon
                                                                color="primary"
                                                                class="mr-2"
                                                                >mdi-email</v-icon
                                                            >
                                                            <span
                                                                class="font-weight-medium"
                                                                >E-mail</span
                                                            >
                                                        </div>
                                                        <p
                                                            class="text-caption grey--text ma-0 mt-1"
                                                        >
                                                            Envio por correio
                                                            eletrônico
                                                        </p>
                                                    </div>
                                                </div>
                                            </v-card-text>
                                        </v-card>
                                        <v-card
                                            class="method-card mt-3"
                                            :class="{
                                                selected:
                                                    novaDivulgacaoForm.enviarVia
                                                        .popup
                                            }"
                                            @click="togglePopup"
                                            outlined
                                        >
                                            <v-card-text class="pa-3">
                                                <div
                                                    class="d-flex align-center"
                                                >
                                                    <v-checkbox
                                                        v-model="
                                                            novaDivulgacaoForm
                                                                .enviarVia.popup
                                                        "
                                                        hide-details
                                                        class="ma-0 pa-0 mr-3"
                                                        color="primary"
                                                        @change="
                                                            validarMetodoEnvio
                                                        "
                                                    ></v-checkbox>
                                                    <div>
                                                        <div
                                                            class="d-flex align-center"
                                                        >
                                                            <v-icon
                                                                color="primary"
                                                                class="mr-2"
                                                                >mdi-message-alert</v-icon
                                                            >
                                                            <span
                                                                class="font-weight-medium"
                                                                >Pop-up</span
                                                            >
                                                        </div>
                                                        <p
                                                            class="text-caption grey--text ma-0 mt-1"
                                                        >
                                                            Notificação na
                                                            plataforma
                                                        </p>
                                                    </div>
                                                </div>
                                            </v-card-text>
                                        </v-card>
                                    </div>
                                    <div
                                        v-if="
                                            !novaDivulgacaoForm.enviarVia
                                                .email &&
                                                !novaDivulgacaoForm.enviarVia
                                                    .popup
                                        "
                                        class="error-text mt-2"
                                    >
                                        <v-icon small color="error" class="mr-1"
                                            >mdi-alert-circle</v-icon
                                        >
                                        Selecione pelo menos um método de envio
                                    </div>
                                </div>
                            </v-col>

                            <v-col cols="12" lg="6">
                                <div class="input-group">
                                    <label class="field-label">
                                        <v-icon
                                            small
                                            class="mr-2"
                                            color="primary"
                                            >mdi-account-plus</v-icon
                                        >
                                        Destinatários extras
                                    </label>
                                    <div class="destinatarios-area mt-2">
                                        <div
                                            v-if="
                                                novaDivulgacaoForm
                                                    .destinatariosAdicionais
                                                    .length > 0
                                            "
                                            class="tags-container mb-3"
                                        >
                                            <v-chip
                                                v-for="(email,
                                                index) in novaDivulgacaoForm.destinatariosAdicionais"
                                                :key="index"
                                                close
                                                small
                                                @click:close="
                                                    removerDestinatario(index)
                                                "
                                                class="ma-1"
                                                color="primary"
                                                text-color="white"
                                            >
                                                <v-icon small left
                                                    >mdi-email</v-icon
                                                >
                                                {{ email }}
                                            </v-chip>
                                        </div>

                                        <v-text-field
                                            v-model="destinatarioInput"
                                            placeholder="adicionar@email.com"
                                            outlined
                                            dense
                                            hide-details="auto"
                                            @keydown.enter="
                                                adicionarDestinatario
                                            "
                                            @keydown="onDestinatarioKeydown"
                                            class="destinatario-input"
                                        >
                                            <template v-slot:append>
                                                <v-btn
                                                    small
                                                    color="primary"
                                                    @click="
                                                        adicionarDestinatario
                                                    "
                                                    :disabled="
                                                        !destinatarioInput.trim()
                                                    "
                                                    text
                                                >
                                                    <v-icon small
                                                        >mdi-plus</v-icon
                                                    >
                                                </v-btn>
                                            </template>
                                        </v-text-field>
                                        <div class="help-text mt-2">
                                            <v-icon small color="grey"
                                                >mdi-information</v-icon
                                            >
                                            Adicione emails extras separados por
                                            vírgula ou Enter
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>

                    <div v-show="stepAtual === 3" class="step-content pa-6">
                        <div class="step-title mb-4">
                            <h3 class="text-h6 font-weight-medium">
                                Revise antes de enviar
                            </h3>
                            <p class="text-body-2 grey--text mt-1">
                                Confira todas as informações da sua divulgação
                            </p>
                        </div>
                        <v-row class="equal-height-row">
                            <v-col cols="12" xl="7" lg="6">
                                <v-card
                                    outlined
                                    class="mb-4 resumo-divulgacao-card"
                                >
                                    <v-card-title class="pb-2">
                                        <v-icon color="primary" class="mr-2"
                                            >mdi-file-document</v-icon
                                        >
                                        Resumo da Divulgação
                                    </v-card-title>
                                    <v-card-text>
                                        <div class="summary-item mb-3">
                                            <strong>Assunto:</strong>
                                            <p class="mt-1 mb-0">
                                                {{ novaDivulgacaoForm.assunto }}
                                            </p>
                                        </div>
                                        <div class="summary-item mb-3">
                                            <strong>Imagem:</strong>
                                            <div
                                                v-if="imagemPreview"
                                                class="mt-1"
                                            >
                                                <div
                                                    class="d-flex align-center"
                                                >
                                                    <img
                                                        :src="imagemPreview"
                                                        alt="Preview"
                                                        class="summary-image mr-3"
                                                    />
                                                    <div class="flex-grow-1">
                                                        <p
                                                            class="text-caption grey--text mb-2"
                                                        >
                                                            {{ nomeArquivo }}
                                                        </p>
                                                        <v-btn
                                                            color="primary"
                                                            x-small
                                                            @click="
                                                                visualizarImagemCompleta(
                                                                    imagemPreview
                                                                )
                                                            "
                                                            class="btn-visualizar-imagem"
                                                        >
                                                            <v-icon x-small left
                                                                >mdi-magnify-plus</v-icon
                                                            >
                                                            Visualizar
                                                        </v-btn>
                                                    </div>
                                                </div>
                                            </div>
                                            <p
                                                v-else
                                                class="text-body-2 grey--text mt-1"
                                            >
                                                Nenhuma imagem selecionada
                                            </p>
                                        </div>
                                        <div class="summary-item mb-3">
                                            <strong>Métodos de envio:</strong>
                                            <div class="mt-1">
                                                <v-chip
                                                    v-if="
                                                        novaDivulgacaoForm
                                                            .enviarVia.email
                                                    "
                                                    small
                                                    color="primary"
                                                    text-color="white"
                                                    class="mr-2"
                                                >
                                                    <v-icon small left
                                                        >mdi-email</v-icon
                                                    >
                                                    E-mail
                                                </v-chip>
                                                <v-chip
                                                    v-if="
                                                        novaDivulgacaoForm
                                                            .enviarVia.popup
                                                    "
                                                    small
                                                    color="primary"
                                                    text-color="white"
                                                >
                                                    <v-icon small left
                                                        >mdi-message-alert</v-icon
                                                    >
                                                    Pop-up
                                                </v-chip>
                                            </div>
                                        </div>
                                        <div class="summary-item mb-3">
                                            <strong>Data de expiração:</strong>
                                            <p class="mt-1 mb-0">
                                                {{
                                                    formatarDataExpiracao(
                                                        novaDivulgacaoForm.expiraEm
                                                    )
                                                }}
                                            </p>
                                        </div>
                                        <div class="summary-item">
                                            <strong>Destinatários:</strong>
                                            <p class="mt-1 mb-0 text-body-2">
                                                Todos os usuários ativos
                                                <span
                                                    v-if="
                                                        novaDivulgacaoForm
                                                            .destinatariosAdicionais
                                                            .length > 0
                                                    "
                                                >
                                                    +
                                                    {{
                                                        novaDivulgacaoForm
                                                            .destinatariosAdicionais
                                                            .length
                                                    }}
                                                    destinatário(s)
                                                    adicional(is)
                                                </span>
                                            </p>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>

                            <v-col cols="12" xl="5" lg="6">
                                <div
                                    v-if="
                                        novaDivulgacaoForm.assunto.trim() &&
                                            (novaDivulgacaoForm.enviarVia
                                                .email ||
                                                novaDivulgacaoForm.enviarVia
                                                    .popup)
                                    "
                                >
                                    <label class="field-label mb-3">
                                        <v-icon
                                            small
                                            class="mr-2"
                                            color="primary"
                                            >mdi-eye</v-icon
                                        >
                                        Pré-visualização final
                                    </label>

                                    <div
                                        v-if="
                                            novaDivulgacaoForm.enviarVia.email
                                        "
                                        class="preview-email mb-4"
                                    >
                                        <div class="preview-label">
                                            <v-icon
                                                small
                                                color="primary"
                                                class="mr-1"
                                                >mdi-email</v-icon
                                            >
                                            <span
                                                class="text-caption font-weight-medium"
                                                >Como ficará o e-mail:</span
                                            >
                                        </div>
                                        <div class="email-preview-container">
                                            <div class="email-header">
                                                <div class="email-from">
                                                    De: sistema@recuperi.com.br
                                                </div>
                                                <div class="email-subject">
                                                    Assunto:
                                                    {{
                                                        novaDivulgacaoForm.assunto ||
                                                            'Sem assunto'
                                                    }}
                                                </div>
                                            </div>
                                            <div class="email-body">
                                                <div class="email-content">
                                                    <div
                                                        v-if="imagemPreview"
                                                        class="email-image"
                                                    >
                                                        <div
                                                            class="position-relative"
                                                        >
                                                            <img
                                                                :src="
                                                                    imagemPreview
                                                                "
                                                                alt="Imagem anexa"
                                                                class="email-img cursor-pointer"
                                                                @click="
                                                                    visualizarImagemCompleta(
                                                                        imagemPreview
                                                                    )
                                                                "
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        v-else
                                                        class="email-image-placeholder"
                                                    >
                                                        <v-icon
                                                            color="grey lighten-1"
                                                            >mdi-image</v-icon
                                                        >
                                                        <span
                                                            class="grey--text text-caption"
                                                            >Imagem será exibida
                                                            aqui</span
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        v-if="
                                            novaDivulgacaoForm.enviarVia.popup
                                        "
                                        class="preview-popup"
                                    >
                                        <div class="preview-label">
                                            <v-icon
                                                small
                                                color="primary"
                                                class="mr-1"
                                                >mdi-message-alert</v-icon
                                            >
                                            <span
                                                class="text-caption font-weight-medium"
                                                >Como ficará o pop-up:</span
                                            >
                                        </div>
                                        <div class="popup-preview-container">
                                            <div class="popup-overlay">
                                                <div class="popup-content">
                                                    <div class="popup-header">
                                                        <h4 class="popup-title">
                                                            {{
                                                                novaDivulgacaoForm.assunto ||
                                                                    'Título da divulgação'
                                                            }}
                                                        </h4>
                                                        <v-icon
                                                            small
                                                            color="grey"
                                                            >mdi-close</v-icon
                                                        >
                                                    </div>
                                                    <div class="popup-body">
                                                        <div
                                                            v-if="imagemPreview"
                                                            class="popup-image"
                                                        >
                                                            <div
                                                                class="position-relative"
                                                            >
                                                                <img
                                                                    :src="
                                                                        imagemPreview
                                                                    "
                                                                    alt="Imagem"
                                                                    class="popup-img cursor-pointer"
                                                                    @click="
                                                                        visualizarImagemCompleta(
                                                                            imagemPreview
                                                                        )
                                                                    "
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            v-else
                                                            class="popup-image-placeholder"
                                                        >
                                                            <v-icon
                                                                color="grey lighten-1"
                                                                size="40"
                                                                >mdi-image</v-icon
                                                            >
                                                            <span
                                                                class="grey--text text-caption"
                                                                >Imagem será
                                                                exibida
                                                                aqui</span
                                                            >
                                                        </div>
                                                    </div>
                                                    <div class="popup-actions">
                                                        <v-btn
                                                            small
                                                            color="primary"
                                                            text
                                                            >Fechar</v-btn
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>

                <v-card-actions
                    class="modal-footer pa-6 d-flex justify-space-between"
                >
                    <div class="footer-left">
                        <v-btn
                            v-if="stepAtual > 1"
                            outlined
                            color="primary"
                            @click="voltarStep"
                            class="btn-voltar"
                        >
                            <v-icon left small>mdi-chevron-left</v-icon>
                            Voltar
                        </v-btn>
                    </div>

                    <div class="footer-right d-flex">
                        <v-btn
                            outlined
                            color="error"
                            @click="cancelarModal"
                            class="btn-cancelar mr-3"
                        >
                            <v-icon left small>mdi-close</v-icon>
                            Cancelar
                        </v-btn>
                        <v-btn
                            v-if="stepAtual < 3"
                            color="primary"
                            @click="avancarStep"
                            class="btn-proximo mr-3"
                            :disabled="!podeAvancar"
                        >
                            Próximo
                            <v-icon right small>mdi-chevron-right</v-icon>
                        </v-btn>
                        <template v-if="stepAtual === 3">
                            <template v-if="!modoEdicao">
                                <v-btn
                                    color="#3B82F6"
                                    @click="salvarRascunho"
                                    class="btn-rascunho mr-3 white--text"
                                    :disabled="
                                        !novaDivulgacaoForm.assunto.trim()
                                    "
                                >
                                    <v-icon left small>mdi-content-save</v-icon>
                                    Salvar Rascunho
                                </v-btn>
                                <v-btn
                                    color="#22C55E"
                                    @click="confirmarEnvio"
                                    class="btn-enviar white--text"
                                    :disabled="!validarFormularioParaEnvio()"
                                >
                                    <v-icon left small>mdi-send</v-icon>
                                    Enviar Agora
                                </v-btn>
                            </template>

                            <template v-else>
                                <v-btn
                                    color="#3B82F6"
                                    @click="salvarEdicaoRascunho"
                                    class="btn-salvar-edicao mr-3 white--text"
                                    :disabled="!validarFormulario()"
                                >
                                    <v-icon left small>mdi-content-save</v-icon>
                                    Salvar Edição
                                </v-btn>
                                <v-btn
                                    v-if="temImagemParaEnvio"
                                    color="#22C55E"
                                    @click="confirmarEnvioRascunho"
                                    class="btn-enviar-rascunho white--text"
                                    :disabled="!validarFormularioParaEnvio()"
                                >
                                    <v-icon left small>mdi-send</v-icon>
                                    Enviar Agora
                                </v-btn>
                            </template>
                        </template>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogConfirmacao" max-width="500px" persistent>
            <v-card class="modal-confirmacao">
                <v-card-title class="justify-center pb-2 pt-6">
                    <v-icon class="warning--text mr-3" size="32">{{
                        getConfirmacaoIcon()
                    }}</v-icon>
                    <h3 class="text-h5 font-weight-medium">
                        {{ getConfirmacaoTitulo() }}
                    </h3>
                </v-card-title>
                <v-card-text class="pa-6 text-center">
                    <p class="text-body-1 mb-4">
                        {{ getConfirmacaoMensagem() }}
                    </p>
                    <p
                        v-if="
                            tipoConfirmacao === 'envio' ||
                                tipoConfirmacao === 'envio-rascunho'
                        "
                        class="text-body-2 grey--text"
                    >
                        <strong
                            >Isso enviará para todos os usuários ativos</strong
                        >
                        <span
                            v-if="
                                novaDivulgacaoForm.destinatariosAdicionais
                                    .length > 0
                            "
                        >
                            +
                            {{
                                novaDivulgacaoForm.destinatariosAdicionais
                                    .length
                            }}
                            destinatário(s) adicional(is)
                        </span>
                    </p>
                    <p
                        v-else-if="tipoConfirmacao === 'edicao'"
                        class="text-body-2 grey--text"
                    >
                        As alterações serão salvas como rascunho e poderão ser
                        enviadas posteriormente.
                    </p>
                </v-card-text>
                <v-card-actions class="pa-6 pt-0 justify-center">
                    <v-btn
                        outlined
                        color="grey"
                        @click="dialogConfirmacao = false"
                        class="mr-3"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        :color="getConfirmacaoCor()"
                        @click="executarAcaoConfirmacao()"
                        class="white--text"
                    >
                        <v-icon left small>{{ getConfirmacaoIcon() }}</v-icon>
                        {{ getConfirmacaoBotao() }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <Snackbar
            v-if="snackbar"
            :mostrarSnackbar="snackbar"
            :corSnackbar="snackbarColor"
            :mensagemSnackbar="mensagemSnackbar"
            @fecharSnackbar="snackbar = false"
        />
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import Snackbar from '@/components/Snackbar.vue';
import moment from 'moment';
import 'moment/locale/pt-br';
import Vue from 'vue';
import DivulgacaoService from '@/services/DivulgacaoService';
export default {
    name: 'GerenciamentoDivulgacoes',
    components: {
        Loading,
        Snackbar
    },
    data() {
        return {
            loading: false,
            snackbar: false,
            snackbarColor: 'success',
            mensagemSnackbar: '',

            headersDesktop: [
                {
                    text: 'Assunto',
                    value: 'assunto',
                    sortable: true,
                    width: '30%'
                },
                {
                    text: 'Métodos de Envio',
                    value: 'enviadoVia',
                    sortable: false,
                    width: '15%'
                },
                {
                    text: 'Data de envio',
                    value: 'data_envio',
                    sortable: true,
                    width: '15%'
                },
                {
                    text: 'Expira em',
                    value: 'expira_em',
                    sortable: true,
                    width: '20%'
                },
                {
                    text: 'Ações',
                    value: 'acoes',
                    sortable: false,
                    width: '20%',
                    align: 'center'
                }
            ],
            headersMobile: [
                {
                    text: 'Divulgação',
                    value: 'assunto',
                    sortable: true,
                    width: '70%'
                },
                {
                    text: 'Ações',
                    value: 'acoes',
                    sortable: false,
                    width: '30%',
                    align: 'center'
                }
            ],
            divulgacoes: [],
            totalItems: 0,

            filtroStatus: 'todos',
            opcoesStatus: [
                { text: 'Todos', value: 'todos' },
                { text: 'Enviados', value: 'enviado' },
                { text: 'Rascunhos', value: 'rascunho' }
            ],

            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['data_envio'],
                sortDesc: [true]
            },

            dialogVisualizacao: false,
            divulgacaoSelecionada: null,

            dialogVisualizacaoImagem: false,
            imagemVisualizacao: null,

            dialogNovaDivulgacao: false,
            dialogConfirmacao: false,
            tipoConfirmacao: 'envio',
            novaDivulgacaoForm: {
                assunto: '',
                arquivo: null,
                expiraEm: null,
                enviarVia: {
                    email: true,
                    popup: false
                },
                destinatariosAdicionais: []
            },
            arquivoSelecionado: null,
            nomeArquivo: '',
            destinatarioInput: '',
            imagemPreview: null,

            stepAtual: 1,
            isDragOver: false,

            divulgacaoService: null
        };
    },
    computed: {
        headers() {
            return this.$vuetify.breakpoint.xs
                ? this.headersMobile
                : this.headersDesktop;
        },
        divulgacoesFiltradas() {
            return this.divulgacoes;
        },
        modoEdicao() {
            return this.novaDivulgacaoForm.id !== undefined;
        },
        podeAvancar() {
            if (this.stepAtual === 1) {
                return (
                    this.novaDivulgacaoForm.assunto.trim().length > 0 &&
                    this.novaDivulgacaoForm.expiraEm &&
                    new Date(this.novaDivulgacaoForm.expiraEm) > new Date()
                );
            } else if (this.stepAtual === 2) {
                return (
                    this.novaDivulgacaoForm.enviarVia.email ||
                    this.novaDivulgacaoForm.enviarVia.popup
                );
            }
            return true;
        },
        temImagemParaEnvio() {
            return (
                this.novaDivulgacaoForm.arquivo !== null ||
                this.imagemPreview !== null
            );
        }
    },
    methods: {
        formatarData(data) {
            if (!data) return '';

            moment.locale('pt-br');

            return moment
                .utc(data)
                .utcOffset('-03:00')
                .format('DD/MM/YYYY HH:mm');
        },
        formatarDataExpiracao(data) {
            if (!data) return '';

            moment.locale('pt-br');

            const dataFormatada = moment.utc(data).isValid()
                ? moment.utc(data).utcOffset('-03:00')
                : moment(data);
            return dataFormatada.format('DD/MM/YYYY HH:mm');
        },
        getStatusExpiracaoColor(dataExpiracao) {
            if (!dataExpiracao) return 'grey';

            const agora = moment().utcOffset('-03:00');
            const expiracao = moment.utc(dataExpiracao).isValid()
                ? moment.utc(dataExpiracao).utcOffset('-03:00')
                : moment(dataExpiracao);

            if (expiracao.isBefore(agora)) {
                return 'error';
            } else if (expiracao.diff(agora, 'days') <= 3) {
                return 'warning';
            } else if (expiracao.diff(agora, 'days') <= 7) {
                return 'orange';
            } else {
                return 'success';
            }
        },
        getStatusExpiracaoIcon(dataExpiracao) {
            if (!dataExpiracao) return 'mdi-clock-outline';

            const agora = moment().utcOffset('-03:00');
            const expiracao = moment.utc(dataExpiracao).isValid()
                ? moment.utc(dataExpiracao).utcOffset('-03:00')
                : moment(dataExpiracao);

            if (expiracao.isBefore(agora)) {
                return 'mdi-clock-alert';
            } else if (expiracao.diff(agora, 'days') <= 3) {
                return 'mdi-clock-alert-outline';
            } else if (expiracao.diff(agora, 'days') <= 7) {
                return 'mdi-clock-outline';
            } else {
                return 'mdi-clock-check';
            }
        },
        getTempoParaExpiracao(dataExpiracao) {
            if (!dataExpiracao) return '';

            moment.locale('pt-br');
            const agora = moment().utcOffset('-03:00');
            const expiracao = moment.utc(dataExpiracao).isValid()
                ? moment.utc(dataExpiracao).utcOffset('-03:00')
                : moment(dataExpiracao);

            if (expiracao.isBefore(agora)) {
                return 'Expirou ' + expiracao.fromNow();
            } else {
                return 'Expira ' + expiracao.fromNow();
            }
        },
        aplicarFiltros() {
            this.options.page = 1;
            this.carregarDivulgacoes();
        },
        novaDivulgacao() {
            this.dialogNovaDivulgacao = true;
            this.resetFormulario();
        },
        visualizarDivulgacao(divulgacao) {
            this.divulgacaoSelecionada = divulgacao;
            this.dialogVisualizacao = true;
        },
        visualizarImagemCompleta(imagemUrl) {
            if (imagemUrl) {
                this.imagemVisualizacao = imagemUrl;
                this.dialogVisualizacaoImagem = true;
            }
        },
        editarDivulgacao(divulgacao) {
            console.log('Editar divulgação:', divulgacao);

            this.dialogVisualizacao = false;

            this.novaDivulgacaoForm = {
                id: divulgacao.id,
                assunto: divulgacao.assunto || '',
                arquivo: null,
                expiraEm: divulgacao.expira_em
                    ? new Date(divulgacao.expira_em).toISOString().substr(0, 16)
                    : null,
                enviarVia: {
                    email: divulgacao.enviadoVia?.email || false,
                    popup: divulgacao.enviadoVia?.popup || false
                },
                destinatariosAdicionais: [
                    ...(divulgacao.destinatariosAdicionais || [])
                ]
            };

            if (divulgacao.imagem) {
                this.imagemPreview = divulgacao.imagem;
                this.nomeArquivo = divulgacao.nomeImagem || 'Imagem existente';
            }

            this.stepAtual = 1;

            this.dialogNovaDivulgacao = true;
            this.mostrarSnackbar('Editando rascunho da divulgação', 'info');
        },
        mostrarSnackbar(mensagem, cor = 'success') {
            this.mensagemSnackbar = mensagem;
            this.snackbarColor = cor;
            this.snackbar = true;
        },
        resetFormulario() {
            const dataExpiracao = new Date();
            dataExpiracao.setDate(dataExpiracao.getDate() + 10);

            this.novaDivulgacaoForm = {
                assunto: '',
                arquivo: null,
                expiraEm: dataExpiracao.toISOString().substr(0, 16),
                enviarVia: {
                    email: true,
                    popup: false
                },
                destinatariosAdicionais: []
            };
            this.arquivoSelecionado = null;
            this.nomeArquivo = '';
            this.destinatarioInput = '';
            this.imagemPreview = null;
            this.stepAtual = 1;
            this.isDragOver = false;
            this.tipoConfirmacao = 'envio';
        },

        avancarStep() {
            if (this.podeAvancar && this.stepAtual < 3) {
                this.stepAtual++;
            }
        },
        voltarStep() {
            if (this.stepAtual > 1) {
                this.stepAtual--;
            }
        },

        onDrop(event) {
            event.preventDefault();
            this.isDragOver = false;
            const files = event.dataTransfer.files;
            if (files.length > 0) {
                const file = files[0];
                if (this.isValidImageFile(file)) {
                    this.arquivoSelecionado = file;
                    this.onFileSelect(file);
                } else {
                    this.mostrarSnackbar(
                        'Por favor, selecione apenas arquivos de imagem (JPG, PNG, GIF)',
                        'error'
                    );
                }
            }
        },
        isValidImageFile(file) {
            const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
            const maxSize = 5 * 1024 * 1024;
            return allowedTypes.includes(file.type) && file.size <= maxSize;
        },

        toggleEmail() {
            this.novaDivulgacaoForm.enviarVia.email = !this.novaDivulgacaoForm
                .enviarVia.email;
            this.validarMetodoEnvio();
        },
        togglePopup() {
            this.novaDivulgacaoForm.enviarVia.popup = !this.novaDivulgacaoForm
                .enviarVia.popup;
            this.validarMetodoEnvio();
        },
        onFileSelect(file) {
            if (file) {
                this.nomeArquivo = file.name;
                this.novaDivulgacaoForm.arquivo = file;

                const reader = new FileReader();
                reader.onload = e => {
                    this.imagemPreview = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        triggerFileSelect() {
            this.$refs.fileInput.$refs.input.click();
        },
        removerArquivo() {
            this.arquivoSelecionado = null;
            this.nomeArquivo = '';
            this.novaDivulgacaoForm.arquivo = null;
            this.imagemPreview = null;
        },
        adicionarDestinatario() {
            if (this.destinatarioInput.trim()) {
                const emails = this.destinatarioInput
                    .split(',')
                    .map(email => email.trim())
                    .filter(email => email);
                emails.forEach(email => {
                    if (
                        this.validarEmail(email) &&
                        !this.novaDivulgacaoForm.destinatariosAdicionais.includes(
                            email
                        )
                    ) {
                        this.novaDivulgacaoForm.destinatariosAdicionais.push(
                            email
                        );
                    }
                });
                this.destinatarioInput = '';
            }
        },
        onDestinatarioKeydown(event) {
            if (event.key === ',' || event.keyCode === 188) {
                event.preventDefault();
                this.adicionarDestinatario();
            }
        },
        removerDestinatario(index) {
            this.novaDivulgacaoForm.destinatariosAdicionais.splice(index, 1);
        },
        validarEmail(email) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(email);
        },
        validarFormulario() {
            const temAssunto =
                this.novaDivulgacaoForm.assunto.trim().length > 0;
            const temMetodoEnvio =
                this.novaDivulgacaoForm.enviarVia.email ||
                this.novaDivulgacaoForm.enviarVia.popup;
            const temDataExpiracao =
                this.novaDivulgacaoForm.expiraEm &&
                new Date(this.novaDivulgacaoForm.expiraEm) > new Date();
            return temAssunto && temMetodoEnvio && temDataExpiracao;
        },
        validarFormularioParaEnvio() {
            const validacaoBasica = this.validarFormulario();
            const temImagem =
                this.novaDivulgacaoForm.arquivo !== null ||
                this.imagemPreview !== null;

            return validacaoBasica && temImagem;
        },
        validarMetodoEnvio() {
            if (
                !this.novaDivulgacaoForm.enviarVia.email &&
                !this.novaDivulgacaoForm.enviarVia.popup
            ) {
                this.$nextTick(() => {
                    this.novaDivulgacaoForm.enviarVia.email = true;
                });
            }
        },
        cancelarModal() {
            this.dialogNovaDivulgacao = false;
            this.dialogConfirmacao = false;
            this.resetFormulario();
        },

        getConfirmacaoIcon() {
            switch (this.tipoConfirmacao) {
                case 'envio':
                case 'envio-rascunho':
                    return 'mdi-send';
                case 'edicao':
                    return 'mdi-content-save';
                default:
                    return 'mdi-alert-circle';
            }
        },
        getConfirmacaoTitulo() {
            switch (this.tipoConfirmacao) {
                case 'envio':
                    return 'Confirmar Envio';
                case 'envio-rascunho':
                    return 'Enviar Rascunho';
                case 'edicao':
                    return 'Confirmar Alterações';
                default:
                    return 'Confirmar Ação';
            }
        },
        getConfirmacaoMensagem() {
            switch (this.tipoConfirmacao) {
                case 'envio':
                    return 'Tem certeza que deseja enviar esta divulgação?';
                case 'envio-rascunho':
                    return 'Tem certeza que deseja enviar este rascunho editado?';
                case 'edicao':
                    return 'Tem certeza que deseja salvar as alterações?';
                default:
                    return 'Tem certeza que deseja continuar?';
            }
        },
        getConfirmacaoCor() {
            switch (this.tipoConfirmacao) {
                case 'envio':
                case 'envio-rascunho':
                    return '#22C55E';
                case 'edicao':
                    return '#3B82F6';
                default:
                    return '#3B82F6';
            }
        },
        getConfirmacaoBotao() {
            switch (this.tipoConfirmacao) {
                case 'envio':
                    return 'Confirmar Envio';
                case 'envio-rascunho':
                    return 'Enviar Agora';
                case 'edicao':
                    return 'Salvar Alterações';
                default:
                    return 'Confirmar';
            }
        },
        executarAcaoConfirmacao() {
            switch (this.tipoConfirmacao) {
                case 'envio':
                    this.enviarDivulgacao();
                    break;
                case 'envio-rascunho':
                    this.enviarRascunhoAgora();
                    break;
                case 'edicao':
                    this.salvarEdicao();
                    break;
                default:
                    this.dialogConfirmacao = false;
            }
        },
        confirmarEnvio() {
            if (!this.validarFormulario()) {
                this.mostrarSnackbar(
                    'Preencha todos os campos obrigatórios',
                    'error'
                );
                return;
            }

            if (!this.modoEdicao && !this.validarFormularioParaEnvio()) {
                this.mostrarSnackbar(
                    'É necessário adicionar uma imagem para enviar a divulgação. Para salvar sem imagem, use "Salvar Rascunho".',
                    'error'
                );
                return;
            }

            this.tipoConfirmacao = this.modoEdicao ? 'edicao' : 'envio';

            this.dialogConfirmacao = true;
        },
        async salvarRascunho() {
            if (!this.novaDivulgacaoForm.assunto.trim()) {
                this.mostrarSnackbar('Assunto é obrigatório', 'error');
                return;
            }
            try {
                this.loading = true;

                if (this.novaDivulgacaoForm.arquivo) {
                    const validacao = this.divulgacaoService.validarImagem(
                        this.novaDivulgacaoForm.arquivo
                    );
                    if (!validacao.valido) {
                        this.mostrarSnackbar(validacao.erro, 'error');
                        return;
                    }
                }
                const dadosDivulgacao = {
                    ...this.novaDivulgacaoForm,
                    status: 'rascunho'
                };
                await this.divulgacaoService.salvarDivulgacao(dadosDivulgacao);
                this.mostrarSnackbar('Rascunho salvo com sucesso!', 'success');
                this.dialogNovaDivulgacao = false;
                this.dialogConfirmacao = false;
                this.resetFormulario();

                this.carregarDivulgacoes();
            } catch (error) {
                console.error('Erro ao salvar rascunho:', error);
                this.mostrarSnackbar('Erro ao salvar rascunho', 'error');
                this.loading = false;
            }
        },
        async enviarDivulgacao() {
            this.dialogConfirmacao = false;
            try {
                this.loading = true;

                if (this.novaDivulgacaoForm.arquivo) {
                    const validacao = this.divulgacaoService.validarImagem(
                        this.novaDivulgacaoForm.arquivo
                    );
                    if (!validacao.valido) {
                        this.mostrarSnackbar(validacao.erro, 'error');
                        return;
                    }
                }

                const dadosDivulgacao = {
                    ...this.novaDivulgacaoForm,
                    status: 'enviado'
                };
                const response = await this.divulgacaoService.salvarDivulgacao(
                    dadosDivulgacao
                );

                if (response.data && response.data.divulgacao_id) {
                    this.mostrarSnackbar(
                        'Divulgação enviada com sucesso!',
                        'success'
                    );
                    this.dialogNovaDivulgacao = false;
                    this.resetFormulario();

                    this.carregarDivulgacoes();
                }
            } catch (error) {
                console.error('Erro ao enviar divulgação:', error);
                this.mostrarSnackbar('Erro ao enviar divulgação', 'error');
                this.loading = false;
            }
        },
        async salvarEdicao() {
            this.dialogConfirmacao = false;
            if (!this.validarFormulario()) {
                this.mostrarSnackbar(
                    'Preencha todos os campos obrigatórios',
                    'error'
                );
                return;
            }
            try {
                this.loading = true;

                if (this.novaDivulgacaoForm.arquivo) {
                    const validacao = this.divulgacaoService.validarImagem(
                        this.novaDivulgacaoForm.arquivo
                    );
                    if (!validacao.valido) {
                        this.mostrarSnackbar(validacao.erro, 'error');
                        return;
                    }
                }
                const dadosDivulgacao = {
                    ...this.novaDivulgacaoForm
                };
                await this.divulgacaoService.salvarDivulgacao(dadosDivulgacao);
                this.mostrarSnackbar(
                    'Alterações salvas com sucesso!',
                    'success'
                );
                this.dialogNovaDivulgacao = false;
                this.resetFormulario();

                this.carregarDivulgacoes();
            } catch (error) {
                console.error('Erro ao salvar edição:', error);
                this.mostrarSnackbar('Erro ao salvar alterações', 'error');
                this.loading = false;
            }
        },
        async salvarEdicaoRascunho() {
            if (!this.validarFormulario()) {
                this.mostrarSnackbar(
                    'Preencha todos os campos obrigatórios',
                    'error'
                );
                return;
            }
            try {
                this.loading = true;

                if (this.novaDivulgacaoForm.arquivo) {
                    const validacao = this.divulgacaoService.validarImagem(
                        this.novaDivulgacaoForm.arquivo
                    );
                    if (!validacao.valido) {
                        this.mostrarSnackbar(validacao.erro, 'error');
                        return;
                    }
                }
                const dadosDivulgacao = {
                    ...this.novaDivulgacaoForm
                };
                await this.divulgacaoService.salvarEdicaoRascunho(
                    this.novaDivulgacaoForm.id,
                    dadosDivulgacao
                );
                this.mostrarSnackbar(
                    'Rascunho editado e salvo com sucesso!',
                    'success'
                );
                this.dialogNovaDivulgacao = false;
                this.resetFormulario();

                this.carregarDivulgacoes();
            } catch (error) {
                console.error('Erro ao salvar edição do rascunho:', error);
                this.mostrarSnackbar(
                    'Erro ao salvar edição do rascunho',
                    'error'
                );
                this.loading = false;
            }
        },
        confirmarEnvioRascunho() {
            if (!this.validarFormularioParaEnvio()) {
                this.mostrarSnackbar(
                    'Para enviar é necessário ter uma imagem e preencher todos os campos obrigatórios',
                    'error'
                );
                return;
            }

            this.tipoConfirmacao = 'envio-rascunho';
            this.dialogConfirmacao = true;
        },
        async enviarRascunhoAgora() {
            this.dialogConfirmacao = false;
            try {
                this.loading = true;

                if (this.novaDivulgacaoForm.arquivo) {
                    const validacao = this.divulgacaoService.validarImagem(
                        this.novaDivulgacaoForm.arquivo
                    );
                    if (!validacao.valido) {
                        this.mostrarSnackbar(validacao.erro, 'error');
                        return;
                    }
                }
                const dadosDivulgacao = {
                    ...this.novaDivulgacaoForm
                };
                await this.divulgacaoService.enviarRascunhoAgora(
                    this.novaDivulgacaoForm.id,
                    dadosDivulgacao
                );
                this.mostrarSnackbar(
                    'Rascunho editado e enviado com sucesso!',
                    'success'
                );
                this.dialogNovaDivulgacao = false;
                this.resetFormulario();

                this.carregarDivulgacoes();
            } catch (error) {
                console.error('Erro ao enviar rascunho editado:', error);
                this.mostrarSnackbar(
                    'Erro ao enviar rascunho editado',
                    'error'
                );
                this.loading = false;
            }
        },
        async carregarDivulgacoes() {
            try {
                this.loading = true;
                const filtros = {
                    expira_em: new Date().toISOString()
                };
                if (this.filtroStatus !== 'todos') {
                    filtros.status = this.filtroStatus;
                }

                const sortBy =
                    this.options.sortBy && this.options.sortBy.length > 0
                        ? this.options.sortBy[0]
                        : '';
                const sortDesc =
                    this.options.sortDesc && this.options.sortDesc.length > 0
                        ? this.options.sortDesc[0]
                        : true;
                const response = await this.divulgacaoService.listarDivulgacoes(
                    filtros,
                    this.options.page,
                    this.options.itemsPerPage,
                    sortBy,
                    sortDesc
                );
                if (response.data && response.data.results) {
                    this.divulgacoes = response.data.results.map(
                        divulgacao => ({
                            ...divulgacao,

                            dataEnvio: divulgacao.data_envio,
                            dataCriacao: divulgacao.data_criacao,
                            dataAtualizacao: divulgacao.data_atualizacao,

                            enviadoVia: {
                                email:
                                    divulgacao.enviar_via_email === true ||
                                    divulgacao.enviar_via_email === 1,
                                popup:
                                    divulgacao.enviar_via_popup === true ||
                                    divulgacao.enviar_via_popup === 1
                            },

                            destinatariosAdicionais: Array.isArray(
                                divulgacao.destinatarios_adicionais
                            )
                                ? divulgacao.destinatarios_adicionais
                                : typeof divulgacao.destinatarios_adicionais ===
                                  'string'
                                ? JSON.parse(
                                      divulgacao.destinatarios_adicionais ||
                                          '[]'
                                  )
                                : [],

                            imagem:
                                divulgacao.imagem_url ||
                                divulgacao.imagem_path_s3,
                            imagemPath: divulgacao.imagem_path_s3,
                            imagemUrl: divulgacao.imagem_url,
                            nomeImagem: divulgacao.imagem_path_s3
                                ? divulgacao.imagem_path_s3.split('/').pop()
                                : null,
                            mimeType: divulgacao.mime_type,

                            usuario: divulgacao.user
                        })
                    );
                    this.totalItems =
                        response.data.total_results ||
                        response.data.results.length;
                } else {
                    this.divulgacoes = [];
                    this.totalItems = 0;
                }
            } catch (error) {
                console.error('Erro ao carregar divulgações:', error);
                this.mostrarSnackbar('Erro ao carregar divulgações', 'error');
                this.divulgacoes = [];
                this.totalItems = 0;
            } finally {
                this.loading = false;
            }
        },
        async buscarDivulgacao(id) {
            try {
                this.loading = true;

                const response = await this.divulgacaoService.buscarDivulgacao(
                    id
                );

                if (response.data) {
                    return {
                        ...response.data,

                        dataEnvio: response.data.data_envio,
                        dataCriacao: response.data.data_criacao,
                        dataAtualizacao: response.data.data_atualizacao,

                        enviadoVia: {
                            email:
                                response.data.enviar_via_email === true ||
                                response.data.enviar_via_email === 1,
                            popup:
                                response.data.enviar_via_popup === true ||
                                response.data.enviar_via_popup === 1
                        },

                        destinatariosAdicionais: Array.isArray(
                            response.data.destinatarios_adicionais
                        )
                            ? response.data.destinatarios_adicionais
                            : typeof response.data.destinatarios_adicionais ===
                              'string'
                            ? JSON.parse(
                                  response.data.destinatarios_adicionais || '[]'
                              )
                            : [],

                        imagem:
                            response.data.imagem_url ||
                            response.data.imagem_path_s3,
                        imagemPath: response.data.imagem_path_s3,
                        imagemUrl: response.data.imagem_url,
                        nomeImagem: response.data.imagem_path_s3
                            ? response.data.imagem_path_s3.split('/').pop()
                            : null,
                        mimeType: response.data.mime_type,

                        usuario: response.data.user
                    };
                }
                return null;
            } catch (error) {
                console.error('Erro ao buscar divulgação:', error);
                this.mostrarSnackbar(
                    'Erro ao carregar dados da divulgação',
                    'error'
                );
                return null;
            } finally {
                this.loading = false;
            }
        }
    },
    watch: {
        options: {
            handler() {
                this.carregarDivulgacoes();
            },
            deep: true
        }
    },
    mounted() {
        this.divulgacaoService = new DivulgacaoService(Vue.http, this.$store);
        this.carregarDivulgacoes();
    }
};
</script>
<style scoped>
* {
    box-sizing: border-box;
}
.destinatarios-adicionais {
    margin-bottom: 20px;
}
.destinatarios-table-container {
    max-height: 200px;
    overflow-y: auto;
    border-radius: 8px;
}
.destinatarios-table-container::-webkit-scrollbar {
    width: 6px;
}
.destinatarios-table-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}
.destinatarios-table-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}
.destinatarios-table-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}
.destinatarios-table-container >>> .v-data-table {
    background-color: transparent;
}
.destinatarios-table-container >>> .v-data-table__wrapper {
    overflow-x: hidden !important;
}
.destinatarios-table-container >>> thead th {
    background-color: #f8f9fa !important;
    font-size: 12px !important;
    padding: 8px 12px !important;
    border-bottom: 1px solid #e9ecef !important;
    color: #495057 !important;
}
.destinatarios-table-container >>> tbody td {
    padding: 6px 12px !important;
    font-size: 13px !important;
    border-bottom: 1px solid #f0f0f0 !important;
    vertical-align: middle;
}
.destinatario-row {
    transition: background-color 0.2s ease;
}
.destinatario-row:hover {
    background-color: #f8f9fa !important;
}
.destinatario-row:nth-child(even) {
    background-color: #fdfdfd;
}
@viewport {
    width: device-width;
    initial-scale: 1;
    maximum-scale: 1;
    user-scalable: no;
}
.container-fluid {
    max-width: 100vw;
    overflow-x: hidden;
    width: 100%;
}
html,
body {
    overflow-x: hidden;
    max-width: 100vw;
    width: 100%;
}
.v-dialog {
    max-width: 100vw !important;
    margin: 0 !important;
}
.v-dialog__content {
    max-width: 100vw !important;
    align-items: flex-start !important;
}
.v-dialog--fullscreen {
    max-width: 100vw !important;
    width: 100vw !important;
    height: 100vh !important;
    margin: 0 !important;
}
@media (max-width: 768px) {
    .mb-4 .v-col:first-child {
        padding-right: 8px !important;
    }
    .mb-4 .v-col:last-child {
        padding-left: 4px !important;
    }

    .mb-4 .v-btn {
        padding: 0 12px !important;
        min-width: auto !important;
        font-size: 0.85rem !important;
    }

    .mb-4 .v-select {
        font-size: 0.85rem !important;
    }
    .mb-4 .v-select .v-input__control {
        min-height: 40px !important;
    }
    .mb-4 .v-select .v-label {
        font-size: 0.8rem !important;
    }
}
@media (max-width: 480px) {
    .mb-4 .v-btn {
        padding: 0 8px !important;
        font-size: 0.8rem !important;
        height: 36px !important;
    }
    .mb-4 .v-btn .v-icon {
        margin-right: 4px !important;
    }
    .mb-4 .v-select .v-input__control {
        min-height: 36px !important;
    }
    .mb-4 .v-select .v-label {
        font-size: 0.75rem !important;
    }
}
.table-container {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: #ccc transparent;
}
.table-container::-webkit-scrollbar {
    height: 6px;
}
.table-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}
.table-container::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
}
.table-container::-webkit-scrollbar-thumb:hover {
    background: #999;
}
.responsive-table {
    width: 100%;
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
}
.responsive-table >>> .v-data-table__wrapper {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: 8px;
}
.responsive-table >>> .v-data-table-header {
    background-color: #f5f5f5;
}
.responsive-table >>> th {
    background-color: #f5f5f5 !important;
    font-weight: 600 !important;
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 1;
}
.responsive-table >>> td {
    padding: 8px 16px !important;
    border-bottom: 1px solid #f0f0f0;
}
.responsive-table >>> tbody tr:hover {
    background-color: #f9f9f9 !important;
}
.subject-cell {
    min-width: 250px;
}
.subject-content {
    flex: 1;
    min-width: 0;
}
.subject-link {
    display: block;
    line-height: 1.3;
    word-break: break-word;
    hyphens: auto;
    transition: color 0.2s ease;
}
.subject-link:hover {
    color: #1976d2 !important;
}
.image-container {
    flex-shrink: 0;
}
.subject-avatar {
    border: 1px solid #e0e0e0;
    transition: transform 0.2s ease;
}
.subject-avatar:hover {
    transform: scale(1.05);
}
.image-name {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.methods-container {
    min-width: 120px;
    gap: 4px;
}
.method-chip {
    font-size: 11px !important;
    height: 24px !important;
    transition: transform 0.2s ease;
    font-weight: 500 !important;
}
.method-chip:hover {
    transform: scale(1.05);
}
.email-chip {
    background-color: #1976d2 !important;
    border-color: #1976d2 !important;
}
.popup-chip {
    background-color: #7c4dff !important;
    border-color: #7c4dff !important;
}
.undefined-chip {
    background-color: #f5f5f5 !important;
    border-color: #e0e0e0 !important;
    color: #666 !important;
}
.chip-icon {
    margin-right: 4px !important;
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
}
.chip-icon:hover {
    transform: scale(1.1);
    color: black !important;
}
.action-btn {
    min-width: auto;
    transition: all 0.2s ease;
}
.action-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
.mobile-pagination {
    padding: 16px;
    display: flex;
    justify-content: center;
    background-color: #f5f5f5;
    border-top: 1px solid #e0e0e0;
    border-radius: 0 0 8px 8px;
}
.mobile-status {
    margin-top: 4px;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    align-items: center;
}
.mobile-status .v-chip {
    margin: 0 !important;
    font-size: 10px !important;
    height: 18px !important;
    font-weight: 500 !important;
    color: white !important;
}
.responsive-table >>> .v-data-table__progress {
    background-color: #f5f5f5;
}
.responsive-table >>> .v-data-table__empty-wrapper {
    padding: 40px 20px;
    text-align: center;
    color: #666;
}
.v-row {
    margin: 0 !important;
    width: 100%;
}
.v-col {
    padding: 8px !important;
    width: 100%;
}
.cursor-pointer {
    cursor: pointer;
}
.responsive-table >>> .v-data-table__wrapper {
    border-radius: 8px;
}
.text-decoration-none:hover {
    text-decoration: underline !important;
}
.v-card {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}
.v-btn {
    border-radius: 6px !important;
}
.v-select {
    border-radius: 6px !important;
}
.pa-6 {
    padding: 24px !important;
}
@media (max-width: 1024px) {
    .subject-cell {
        min-width: 200px;
    }
    .responsive-table >>> td {
        padding: 6px 12px !important;
    }
    .methods-container {
        min-width: 100px;
    }
}
@media (max-width: 960px) {
    .table-container {
        margin: 0 -8px;
    }
    .subject-cell {
        min-width: 180px;
    }
    .responsive-table >>> .v-data-table__wrapper {
        overflow-x: auto;
    }
    .responsive-table >>> table {
        min-width: 600px;
    }
}
.pa-6 {
    padding: 24px !important;
}
@media (max-width: 768px) {
    .v-row {
        flex-direction: column;
    }
    .text-right {
        text-align: left !important;
    }
    .v-col {
        padding: 6px !important;
        width: 100% !important;
        max-width: 100% !important;
    }

    .destinatarios-table-container {
        max-height: 150px;
    }
    .destinatarios-table-container >>> thead th {
        font-size: 11px !important;
        padding: 6px 8px !important;
    }
    .destinatarios-table-container >>> tbody td {
        font-size: 12px !important;
        padding: 4px 8px !important;
    }

    .table-container {
        margin: 0 -12px;
        border-radius: 0;
    }
    .responsive-table {
        border-radius: 0 !important;
    }
    .responsive-table >>> .v-data-table__wrapper {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        border-radius: 0;
    }
    .responsive-table >>> table {
        width: 100%;
        min-width: auto;
    }
    .responsive-table >>> th,
    .responsive-table >>> td {
        padding: 8px 12px !important;
        font-size: 14px;
    }
    .responsive-table >>> th {
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: #f5f5f5 !important;
    }

    .subject-cell {
        min-width: auto;
    }
    .subject-content {
        min-width: 0;
    }
    .subject-link {
        font-size: 14px;
        line-height: 1.2;
    }
    .image-name {
        display: none;
    }
    .methods-container {
        min-width: auto;
        justify-content: flex-start;
    }
    .method-chip {
        font-size: 10px !important;
        height: 20px !important;
        margin: 1px;
    }
    .action-btn {
        padding: 0 8px !important;
        min-width: 60px !important;
        height: 28px !important;
        font-size: 12px !important;
    }
    .mobile-status .v-chip {
        font-size: 10px !important;
        height: 18px !important;
        margin: 0 2px 2px 0 !important;
        font-weight: 500 !important;
        color: black !important;
    }

    .mobile-status .v-chip.email-chip,
    .mobile-status .v-chip[style*='#1976d2'] {
        background-color: #1976d2 !important;
        border-color: #1976d2 !important;
        color: #1976d2 !important;
    }
    .mobile-status .v-chip.popup-chip,
    .mobile-status .v-chip[style*='#7c4dff'] {
        background-color: #7c4dff !important;
        border-color: #7c4dff !important;
        color: #7c4dff !important;
    }

    .v-card {
        margin: 8px 4px !important;
        border-radius: 12px !important;
    }
    .pa-6 {
        padding: 16px !important;
    }

    .responsive-table >>> .v-data-footer {
        flex-wrap: wrap;
        gap: 8px;
        padding: 8px 12px !important;
    }
    .responsive-table >>> .v-data-footer__select {
        margin: 0 !important;
    }
    .responsive-table >>> .v-data-footer__pagination {
        margin: 4px 0 !important;
    }
}
@media (max-width: 480px) {
    .v-col {
        padding: 4px !important;
    }
    .pa-6 {
        padding: 12px !important;
    }
    .v-card {
        margin: 4px 2px !important;
    }

    .destinatarios-table-container {
        max-height: 120px;
    }
    .destinatarios-table-container >>> thead th {
        font-size: 10px !important;
        padding: 4px 6px !important;
    }
    .destinatarios-table-container >>> tbody td {
        font-size: 11px !important;
        padding: 3px 6px !important;
    }

    .table-container {
        margin: 0 -8px;
    }
    .responsive-table >>> th,
    .responsive-table >>> td {
        padding: 6px 8px !important;
        font-size: 13px;
    }
    .subject-cell {
        min-width: auto;
    }
    .subject-avatar {
        width: 28px !important;
        height: 28px !important;
    }
    .subject-link {
        font-size: 13px;
        line-height: 1.1;
    }
    .methods-container {
        gap: 2px;
    }
    .method-chip {
        font-size: 9px !important;
        height: 18px !important;
        padding: 0 4px !important;
    }
    .method-chip .v-icon {
        font-size: 10px !important;
        margin-right: 2px !important;
    }
    .action-btn {
        padding: 0 6px !important;
        min-width: 50px !important;
        height: 24px !important;
        font-size: 11px !important;
    }
    .action-btn .v-icon {
        font-size: 12px !important;
        margin-right: 2px !important;
    }
    .mobile-pagination {
        padding: 12px;
    }
    .mobile-pagination >>> .v-pagination__item {
        width: 28px !important;
        height: 28px !important;
        font-size: 12px !important;
    }

    .v-btn {
        min-width: auto !important;
        padding: 0 12px !important;
    }

    .v-select {
        width: 100% !important;
    }

    .responsive-table >>> th {
        font-size: 12px !important;
        font-weight: 700 !important;
    }
}
@media (max-width: 375px) {
    .table-container {
        margin: 0 -6px;
    }
    .responsive-table >>> th,
    .responsive-table >>> td {
        padding: 4px 6px !important;
        font-size: 12px;
    }
    .subject-avatar {
        width: 24px !important;
        height: 24px !important;
    }
    .subject-link {
        font-size: 12px;
    }
    .method-chip {
        font-size: 8px !important;
        height: 16px !important;
        padding: 0 3px !important;
    }
    .action-btn {
        padding: 0 4px !important;
        min-width: 40px !important;
        height: 22px !important;
        font-size: 10px !important;
    }
    .mobile-status .v-chip {
        font-size: 8px !important;
        height: 14px !important;
        margin: 0 1px 1px 0 !important;
        padding: 0 4px !important;
        color: white !important;
    }
    .mobile-status .v-chip .v-icon {
        font-size: 10px !important;
        margin-right: 2px !important;
    }
}
.modal-nova-divulgacao {
    border-radius: 20px !important;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.15) !important;
    font-family: 'Inter', 'Roboto', sans-serif;
    overflow: hidden;
    max-width: 1200px !important;
    width: 50vw !important;
}
.modal-header {
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    border-bottom: 1px solid #e2e8f0;
    min-height: 80px;
}
.header-icon {
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}
.header-text h2 {
    line-height: 1.2;
}
.progress-indicator {
    background-color: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
}
.progress-indicator .v-stepper {
    background-color: transparent !important;
}
.progress-indicator .v-stepper__header {
    background-color: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
}
.progress-indicator .v-stepper__step {
    padding: 12px 24px !important;
}
.progress-indicator .v-stepper__step__step {
    width: 32px !important;
    height: 32px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
}
.progress-indicator .v-stepper__label {
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #64748b !important;
}
.step-content {
    min-height: 500px;
    background-color: #ffffff;
}
.step-title {
    border-bottom: 1px solid #f1f5f9;
    padding-bottom: 16px;
    margin-bottom: 24px;
}
.step-title h3 {
    color: #1e293b;
    margin-bottom: 4px;
}
.input-group {
    margin-bottom: 24px;
}
.field-label {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 14px;
    color: #374151;
    margin-bottom: 8px;
}
.upload-zone {
    border: 2px dashed #d1d5db;
    border-radius: 12px;
    padding: 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #fafafa;
    position: relative;
    overflow: hidden;
}
.upload-zone:hover {
    border-color: #3b82f6;
    background-color: #f0f9ff;
}
.upload-zone.dragover {
    border-color: #22c55e;
    background-color: #f0fdf4;
    transform: scale(1.02);
}
.upload-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 120px;
}
.upload-preview {
    position: relative;
    display: inline-block;
}
.preview-img {
    max-width: 100%;
    max-height: 200px;
    object-fit: contain;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.upload-overlay {
    position: absolute;
    top: 8px;
    right: 8px;
    opacity: 0;
    transition: opacity 0.3s ease;
}
.upload-preview:hover .upload-overlay {
    opacity: 1;
}
.method-cards {
    display: flex;
    flex-direction: column;
    gap: 12px;
}
.method-card {
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 12px !important;
    background-color: #fafafa;
}
.method-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
}
.method-card.selected {
    border-color: #3b82f6 !important;
    background-color: #f0f9ff;
    box-shadow: 0 0 0 1px #3b82f6;
}
.destinatarios-area {
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 16px;
    background-color: #fafafa;
}
.tags-container {
    min-height: 40px;
    border-radius: 8px;
    padding: 8px;
    background-color: #ffffff;
    border: 1px solid #e5e7eb;
}
.equal-height-row {
    display: flex;
    align-items: stretch;
}
.equal-height-row .v-col {
    display: flex;
    flex-direction: column;
}
.resumo-divulgacao-card {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.resumo-divulgacao-card .v-card-text {
    flex: 1;
    display: flex;
    flex-direction: column;
}
.summary-item {
    padding: 12px 0;
    border-bottom: 1px solid #f1f5f9;
}
.summary-item:last-child {
    border-bottom: none;
}
.summary-image {
    max-width: 120px;
    max-height: 80px;
    object-fit: contain;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.modal-footer {
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    border-top: 1px solid #e2e8f0;
    min-height: 80px;
}
.footer-left,
.footer-right {
    display: flex;
    align-items: center;
}
.v-btn {
    text-transform: none !important;
    font-weight: 500 !important;
    border-radius: 10px !important;
    letter-spacing: 0.025em !important;
    transition: all 0.3s ease !important;
}
.btn-voltar {
    border-color: #6b7280 !important;
    color: #6b7280 !important;
}
.btn-voltar:hover {
    background-color: #f9fafb !important;
    border-color: #374151 !important;
    color: #374151 !important;
    transform: translateX(-2px) !important;
}
.btn-cancelar {
    border-color: #ef4444 !important;
    color: #ef4444 !important;
}
.btn-cancelar:hover {
    background-color: #fef2f2 !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.2) !important;
}
.btn-proximo {
    background-color: #3b82f6 !important;
    color: white !important;
}
.btn-proximo:hover {
    background-color: #2563eb !important;
    transform: translateX(2px) !important;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
}
.btn-rascunho {
    background-color: #6366f1 !important;
}
.btn-rascunho:hover {
    background-color: #4f46e5 !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3) !important;
}
.btn-enviar {
    background-color: #22c55e !important;
}
.btn-enviar:hover {
    background-color: #16a34a !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(34, 197, 94, 0.3) !important;
}
.close-btn {
    background-color: rgba(107, 114, 128, 0.1) !important;
    border-radius: 50% !important;
    width: 48px !important;
    height: 48px !important;
    transition: all 0.3s ease !important;
}
.close-btn:hover {
    background-color: rgba(239, 68, 68, 0.1) !important;
    transform: scale(1.1) rotate(90deg) !important;
}
.close-btn .v-icon {
    color: #6b7280 !important;
    transition: color 0.3s ease !important;
}
.close-btn:hover .v-icon {
    color: #ef4444 !important;
}
.help-text {
    font-size: 12px;
    color: #6b7280;
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 4px;
}
.error-text {
    color: #ef4444;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
}
@media (min-width: 1441px) {
    .modal-nova-divulgacao {
        max-width: 1200px !important;
        width: 85vw !important;
    }
}
@media (max-width: 1440px) {
    .modal-nova-divulgacao {
        max-width: 1100px !important;
        width: 50vw !important;
        margin: 20px;
    }
    .step-content {
        min-height: 450px;
    }
}
@media (max-width: 1200px) {
    .modal-nova-divulgacao {
        max-width: 95vw !important;
        width: 95vw !important;
        margin: 16px;
    }
    .step-content {
        padding: 28px 20px !important;
        min-height: 400px;
    }
    .header-icon {
        width: 50px;
        height: 50px;
    }
    .header-text h2 {
        font-size: 1.4rem !important;
    }
}
@media (max-width: 960px) {
    .modal-nova-divulgacao {
        max-width: 100vw !important;
        width: 100vw !important;
        margin: 0;
        border-radius: 0 !important;
    }
    .step-content {
        padding: 20px 16px !important;
        min-height: 350px;
    }
    .progress-indicator .v-stepper__step {
        padding: 8px 12px !important;
    }
    .progress-indicator .v-stepper__label {
        font-size: 12px !important;
    }
    .upload-zone {
        padding: 18px 14px;
    }
    .upload-empty {
        min-height: 100px;
    }
    .upload-empty .v-icon {
        font-size: 40px !important;
    }
}
@media (max-width: 768px) {
    .modal-nova-divulgacao {
        max-width: 100vw !important;
        width: 100vw !important;
        margin: 4px;
        border-radius: 12px !important;
    }
    .modal-header {
        flex-direction: row;
        text-align: left;
        gap: 12px;
        min-height: auto;
        padding: 16px 12px !important;
    }
    .header-content {
        flex-direction: row;
        text-align: left;
        width: 100%;
        align-items: center;
    }
    .header-icon {
        margin-bottom: 0;
        width: 44px;
        height: 44px;
        flex-shrink: 0;
    }
    .header-text {
        margin-left: 12px !important;
        flex: 1;
    }
    .header-text h2 {
        font-size: 1.2rem !important;
        margin-bottom: 2px !important;
        line-height: 1.3;
    }
    .header-text p {
        font-size: 0.85rem !important;
        line-height: 1.2;
    }
    .step-content {
        padding: 16px 12px !important;
        min-height: auto;
    }
    .step-title {
        text-align: left;
        margin-bottom: 16px;
    }
    .step-title h3 {
        font-size: 1.15rem !important;
    }
    .upload-zone {
        padding: 14px 10px;
        margin-top: 8px !important;
    }
    .upload-empty {
        min-height: 80px;
    }
    .upload-empty p {
        font-size: 0.85rem !important;
    }
    .upload-empty .v-icon {
        font-size: 36px !important;
    }
    .preview-img {
        max-height: 150px !important;
    }
    .method-cards {
        gap: 8px;
    }
    .method-card .v-card-text {
        padding: 14px 10px !important;
    }
    .destinatarios-area {
        padding: 10px;
    }
    .tags-container {
        padding: 6px;
    }
    .modal-footer {
        flex-direction: row;
        gap: 8px;
        padding: 16px 12px !important;
        min-height: auto;
        justify-content: space-between;
    }
    .footer-left,
    .footer-right {
        width: auto;
        justify-content: flex-start;
    }
    .footer-right {
        flex-direction: row;
        gap: 8px;
    }
    .footer-right .v-btn {
        width: auto;
        max-width: none;
        margin: 0 !important;
        height: 38px !important;
        font-size: 0.9rem !important;
        padding: 0 16px !important;
    }
    .btn-voltar {
        width: auto;
        max-width: none;
        height: 38px !important;
        margin: 0 !important;
    }

    .email-preview-container {
        font-size: 11px !important;
    }
    .email-title {
        font-size: 12px !important;
    }
    .popup-content {
        max-width: 100%;
        margin: 0 6px;
    }
    .popup-title {
        font-size: 11px !important;
    }
    .summary-image {
        max-width: 100px;
        max-height: 60px;
    }
}
@media (max-width: 600px) {
    .progress-indicator {
        padding: 12px 6px 0 !important;
    }
    .progress-indicator .v-stepper__step {
        padding: 4px 6px !important;
    }
    .progress-indicator .v-stepper__step__step {
        width: 26px !important;
        height: 26px !important;
        font-size: 11px !important;
    }
    .progress-indicator .v-stepper__label {
        font-size: 10px !important;
    }
    .step-content {
        padding: 14px 10px !important;
    }
    .input-group {
        margin-bottom: 18px;
    }
    .field-label {
        font-size: 13px !important;
        margin-bottom: 6px;
    }
    .upload-zone {
        padding: 12px 8px;
    }
    .upload-empty {
        min-height: 70px;
    }
    .upload-empty p {
        font-size: 0.8rem !important;
    }
    .upload-empty .v-icon {
        font-size: 32px !important;
    }
    .method-card .v-card-text {
        padding: 12px 8px !important;
    }
    .method-card .font-weight-medium {
        font-size: 0.9rem !important;
    }
    .method-card .text-caption {
        font-size: 0.75rem !important;
    }
    .modal-footer {
        padding: 14px 10px !important;
        flex-direction: column;
        gap: 10px;
    }
    .footer-left,
    .footer-right {
        width: 100%;
        justify-content: center;
    }
    .footer-right {
        flex-direction: column;
        gap: 8px;
    }
    .footer-right .v-btn {
        width: 100%;
        max-width: 280px;
        margin: 0 !important;
        height: 40px !important;
        font-size: 0.9rem !important;
    }
    .btn-voltar {
        width: 100%;
        max-width: 280px;
        height: 40px !important;
        margin: 0 0 8px 0 !important;
    }
}
@media (max-width: 480px) {
    .modal-nova-divulgacao {
        border-radius: 8px !important;
        margin: 2px;
        max-width: 100vw !important;
        width: 100vw !important;
    }
    .modal-header {
        padding: 12px 8px !important;
    }
    .header-icon {
        width: 36px;
        height: 36px;
        border-radius: 10px;
    }
    .header-text h2 {
        font-size: 1.05rem !important;
    }
    .header-text p {
        font-size: 0.75rem !important;
    }
    .step-content {
        padding: 10px 6px !important;
    }
    .step-title h3 {
        font-size: 1.05rem !important;
    }
    .step-title p {
        font-size: 0.75rem !important;
    }
    .upload-zone {
        padding: 10px 6px;
        border-radius: 8px;
    }
    .upload-empty {
        min-height: 60px;
    }
    .upload-empty .v-icon {
        font-size: 28px !important;
    }
    .upload-empty p {
        font-size: 0.7rem !important;
        margin: 4px 0 !important;
    }
    .close-btn {
        width: 32px !important;
        height: 32px !important;
    }
    .close-btn .v-icon {
        font-size: 16px !important;
    }
}
@media (max-width: 375px) {
    .modal-nova-divulgacao {
        margin: 1px;
        border-radius: 6px !important;
    }
    .step-content {
        padding: 8px 4px !important;
    }
    .modal-header {
        padding: 10px 6px !important;
    }
    .modal-footer {
        padding: 10px 6px !important;
    }
    .header-icon {
        width: 32px;
        height: 32px;
    }
    .header-text h2 {
        font-size: 0.95rem !important;
    }
    .header-text p {
        font-size: 0.7rem !important;
    }
    .footer-right .v-btn {
        height: 36px !important;
        font-size: 0.8rem !important;
    }
    .upload-zone {
        padding: 8px 4px;
    }
    .upload-empty .v-icon {
        font-size: 24px !important;
    }
    .upload-empty p {
        font-size: 0.65rem !important;
    }
}
@media (max-width: 959px) {
    .v-dialog--fullscreen .modal-nova-divulgacao {
        border-radius: 0 !important;
        margin: 0 !important;
        max-width: 100vw !important;
        width: 100vw !important;
        height: 100vh !important;
        max-height: 100vh !important;
    }
    .v-dialog--fullscreen .step-content {
        min-height: calc(100vh - 220px) !important;
        overflow-y: auto;
        padding: 16px 12px !important;
    }
    .v-dialog--fullscreen .modal-footer {
        position: sticky;
        bottom: 0;
        background: white;
        border-top: 2px solid #e2e8f0;
        z-index: 10;
        padding: 16px 12px !important;
    }
    .v-dialog--fullscreen .modal-header {
        position: sticky;
        top: 0;
        background: white;
        border-bottom: 2px solid #e2e8f0;
        z-index: 10;
    }
    .v-dialog--fullscreen .progress-indicator {
        position: sticky;
        top: 72px;
        background: white;
        border-bottom: 1px solid #e2e8f0;
        z-index: 9;
    }
}
@keyframes slideInRight {
    from {
        opacity: 0;
        transform: translateX(30px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}
@keyframes slideInLeft {
    from {
        opacity: 0;
        transform: translateX(-30px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}
.step-content {
    animation: slideInRight 0.3s ease-out;
}
.v-text-field--outlined >>> .v-input__control:focus-within {
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.v-btn:focus {
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2) !important;
}
.upload-zone:focus {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
}
.method-card:focus {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
}
.modal-confirmacao {
    border-radius: 16px !important;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
    font-family: 'Inter', 'Roboto', sans-serif;
}
.modal-confirmacao .v-card-title {
    background-color: #fef3c7;
    border-bottom: 1px solid #f59e0b;
}
.modal-confirmacao .v-icon.warning--text {
    color: #f59e0b !important;
}
.modal-confirmacao .v-card-text {
    font-size: 16px;
    line-height: 1.5;
}
.modal-confirmacao .v-btn {
    text-transform: none !important;
    font-weight: 500 !important;
    border-radius: 8px !important;
    padding: 12px 24px !important;
    min-width: 120px !important;
}
.modal-confirmacao .v-btn[outlined] {
    border-color: #6b7280 !important;
    color: #6b7280 !important;
}
.modal-confirmacao .v-btn[outlined]:hover {
    background-color: #f9fafb !important;
    border-color: #374151 !important;
    color: #374151 !important;
}
.preview-label {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    font-weight: 500;
    color: #374151;
}
.preview-email {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
    background-color: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    padding: 10px;
}
.email-preview-container {
    font-family: Arial, sans-serif;
    font-size: 12px;
    background-color: #ffffff;
}
.email-header {
    background-color: #f8fafc;
    padding: 8px 12px;
    border-bottom: 1px solid #e5e7eb;
}
.email-from,
.email-subject {
    margin-bottom: 2px;
    color: #6b7280;
    font-size: 11px;
}
.email-subject {
    font-weight: 600;
    color: #374151;
}
.email-body {
    padding: 12px;
    background-color: #ffffff;
}
.email-content {
    text-align: center;
}
.email-title {
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 12px;
    line-height: 1.3;
}
.email-image {
    margin: 8px 0;
}
.email-img {
    max-width: 100%;
    max-height: 80px;
    object-fit: contain;
    border-radius: 4px;
    border: 1px solid #e5e7eb;
}
.email-image-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60px;
    background-color: #f9fafb;
    border: 1px dashed #d1d5db;
    border-radius: 4px;
    margin: 8px 0;
}
.preview-popup {
    margin-top: 16px;
}
.popup-preview-container {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
    background-color: #f3f4f6;
    padding: 16px;
    position: relative;
}
.popup-overlay {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.popup-content {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    width: 100%;
    max-width: 280px;
    overflow: hidden;
    font-size: 12px;
}
.popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background-color: #3b82f6;
    color: white;
}
.popup-title {
    font-size: 13px;
    font-weight: 600;
    margin: 0;
    line-height: 1.3;
    flex: 1;
    margin-right: 8px;
}
.popup-body {
    padding: 16px;
    text-align: center;
}
.popup-image {
    margin-bottom: 12px;
}
.popup-img {
    max-width: 100%;
    max-height: 80px;
    object-fit: contain;
    border-radius: 4px;
    border: 1px solid #e5e7eb;
}
.popup-image-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60px;
    background-color: #f9fafb;
    border: 1px dashed #d1d5db;
    border-radius: 4px;
    margin-bottom: 12px;
}
.popup-actions {
    padding: 8px 16px 16px;
    text-align: center;
}
.popup-actions .v-btn {
    font-size: 11px !important;
    height: 28px !important;
    min-width: 60px !important;
    text-transform: none !important;
}
@media (max-width: 768px) {
    .email-preview-container {
        font-size: 11px;
    }
    .email-title {
        font-size: 13px;
    }
    .popup-content {
        max-width: 100%;
    }
    .popup-title {
        font-size: 12px;
    }
}
.v-data-table >>> tbody tr td {
    vertical-align: top !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
}
.v-avatar.v-avatar--tile.rounded-4 {
    border: 1px solid #e0e0e0;
    overflow: hidden;
}
.v-data-table >>> td .text-body-2 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.4;
    max-height: calc(1.4em * 3);
}
.divulgacao-info {
    min-height: 100px;
}
.divulgacao-info .v-card {
    background-color: #fafafa;
    border: 1px solid #e0e0e0;
}
.methods-container {
    gap: 6px;
    align-items: flex-start;
    min-width: 120px;
}
.method-chip {
    font-size: 11px !important;
    font-weight: 500 !important;
    height: 24px !important;
    border-radius: 12px !important;
    transition: all 0.3s ease !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
    border-width: 1.5px !important;
}
.method-chip:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
}
.method-chip .chip-icon {
    margin-right: 4px !important;
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
}
.email-chip {
    background-color: transparent !important;
    border-color: #1976d2 !important;
    color: #1976d2 !important;
}
.email-chip:hover {
    background-color: #1976d2 !important;
    color: black !important;
}
.email-chip .chip-icon {
    color: #1976d2 !important;
}
.email-chip:hover .chip-icon {
    color: black !important;
}
.popup-chip:hover .chip-icon {
    color: black !important;
}
.popup-chip {
    background-color: transparent !important;
    border-color: #7c4dff !important;
    color: #7c4dff !important;
}
.popup-chip:hover {
    background-color: #7c4dff !important;
    color: black !important;
}
.popup-chip .chip-icon {
    color: #7c4dff !important;
}
.popup-chip:hover .chip-icon {
    color: black !important;
}
.undefined-chip {
    background-color: #f5f5f5 !important;
    border-color: #bdbdbd !important;
    color: #757575 !important;
}
.undefined-chip:hover {
    background-color: #eeeeee !important;
    border-color: #9e9e9e !important;
}
.undefined-chip .chip-icon {
    color: #9e9e9e !important;
}
@media (max-width: 768px) {
    .methods-container {
        min-width: 100px;
    }
    .method-chip {
        font-size: 10px !important;
        height: 22px !important;
    }
    .method-chip .chip-icon {
        font-size: 16px !important;
        width: 16px !important;
        height: 16px !important;
        margin-right: 2px !important;
    }
}
@media (max-width: 480px) {
    .methods-container {
        min-width: 80px;
    }
    .method-chip {
        font-size: 9px !important;
        height: 20px !important;
        padding: 0 8px !important;
    }
    .method-chip .chip-icon {
        font-size: 16px !important;
        width: 16px !important;
        height: 16px !important;
    }
}
.btn-editar {
    background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%) !important;
    color: white !important;
    border-radius: 8px !important;
    transition: all 0.3s ease !important;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3) !important;
}
.btn-editar:hover {
    background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%) !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4) !important;
}
.v-card-actions .v-btn[color='grey'] {
    border-radius: 8px !important;
    transition: all 0.3s ease !important;
}
.v-card-actions .v-btn[color='grey']:hover {
    background-color: #f9fafb !important;
    color: #374151 !important;
    transform: translateY(-1px) !important;
}
@media (max-width: 768px) {
    .btn-editar {
        width: 100% !important;
        margin-bottom: 6px !important;
        height: 40px !important;
        font-size: 13px !important;
        padding: 0 12px !important;
        max-width: 150px !important;
    }
    .btn-editar .v-icon {
        font-size: 16px !important;
        margin-right: 6px !important;
    }
    .v-card-actions {
        flex-direction: column !important;
        align-items: stretch !important;
        padding: 12px !important;
    }
    .v-card-actions .v-spacer {
        display: none !important;
    }
    .v-card-actions .v-btn {
        margin: 3px 0 !important;
        min-height: 40px !important;
        max-height: 40px !important;
    }
    .v-card-actions .v-btn[color='grey'] {
        height: 38px !important;
        font-size: 13px !important;
    }
}
@media (max-width: 480px) {
    .btn-editar {
        height: 42px !important;
        font-size: 14px !important;
        padding: 0 14px !important;
    }
    .btn-editar .v-icon {
        font-size: 18px !important;
        margin-right: 8px !important;
    }
    .v-card-actions {
        padding: 14px !important;
    }
    .v-card-actions .v-btn {
        min-height: 42px !important;
        max-height: 42px !important;
    }
}
.modal-visualizacao-imagem {
    border-radius: 16px !important;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25) !important;
    overflow: hidden;
    background-color: #ffffff;
    padding: 10px !important;
}
.modal-visualizacao-imagem .v-card-title {
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    border-bottom: 1px solid #e2e8f0;
    min-height: 60px;
}
.imagem-fullscreen {
    cursor: zoom-in;
    transition: transform 0.3s ease;
    border-radius: 8px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
}
@media (max-width: 768px) {
    .modal-visualizacao-imagem {
        border-radius: 0 !important;
        margin: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
    }

    .modal-visualizacao-imagem .v-card-text {
        min-height: calc(100vh - 120px) !important;
    }

    .imagem-fullscreen {
        max-height: calc(100vh - 120px) !important;
    }
}
.v-overlay--active {
    backdrop-filter: blur(2px);
}
.btn-visualizar-imagem {
    transition: all 0.3s ease !important;
}
.btn-visualizar-imagem:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
}
.btn-overlay {
    transition: opacity 0.3s ease !important;
}
.position-relative:hover .btn-overlay {
    opacity: 1 !important;
}
.cursor-pointer {
    cursor: pointer !important;
    transition: transform 0.2s ease !important;
}
.cursor-pointer:hover {
    transform: scale(1.02) !important;
}
.upload-overlay {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
}
</style>
